import React, { useEffect, useState } from 'react';
import { create } from '../../services/upload-files.service';
import { useNavigate } from 'react-router';
import useFetch from '../../hooks/useFetch';
import { exportToExcel } from '../../services/fetch-data.service';
const EXPORT_CDPREPORT_API = 'https://dev.sustainabilitypro.io/api/v1/export_cdp?year=2025'

const GRIQNA = () => {
    const [formState, setFormState] = useState({});


    const formFeilds = {
        "fields": [
            {
                "id": 0,
                "field_label": "C0 Introduction",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 0.1,
                "field_label": "Give a general description and introduction to your organization.",
                "field_name": "(C0.1)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 0.1,
                        "answer_label": "",
                        "answer_description": "",
                        "answer_type": "textarea",
                        "answer_name": "answer_0.1",

                        "answer_options": []
                    }
                ]
            },
            {
                "id": 0.2,
                "field_label": "State the start and end date of the year for which you are reporting data and indicate whether you will be providing emissions data for past reporting years.",
                "field_name": "(C0.2)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 0.20,
                        "answer_label": "Start date",
                        "answer_description": "",
                        "answer_type": "date",
                        "answer_name": "startdate",
                    },
                    {
                        "answer_id": 0.21,
                        "answer_label": "End date",
                        "answer_description": "",
                        "answer_type": "date",
                        "answer_name": "enddate",
                    },
                    {
                        "answer_id": 0.22,
                        "answer_label": "Indicate if you are providing emissions data for past reporting years",
                        "answer_description": "select in yes or no",
                        "answer_type": "radio",
                        "answer_name": "answer_0.22",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" }
                        ]
                    },
                    {
                        "answer_id": 0.23,
                        "answer_label": "Select the number of past reporting years you will be providing Scope 1 emissions data for*",
                        "answer_description": "select in any option",
                        "answer_type": "radio",
                        "answer_name": "answer_0.23",
                        "answer_options": [
                            { "key": "1year", "value": "1 Year" },
                            { "key": "2years", "value": "2 Years" },
                            { "key": "3years", "value": "3 Years" },
                            { "key": "4years", "value": "4 Years" },
                            { "key": "5years", "value": "5 Years" },
                            { "key": "Null", "value": "Not providing past emissions data for Scope 1" }
                        ]
                    },
                    {
                        "answer_id": 0.24,
                        "answer_label": "Select the number of past reporting years you will be providing Scope 2 emissions data for*",
                        "answer_description": "select in any option",
                        "answer_type": "radio",
                        "answer_name": "answer_0.24",
                        "answer_options": [
                            { "key": "1year", "value": "1 Year" },
                            { "key": "2years", "value": "2 Years" },
                            { "key": "3years", "value": "3 Years" },
                            { "key": "4years", "value": "4 Years" },
                            { "key": "5years", "value": "5 Years" },
                            { "key": "Null", "value": "Not providing past emissions data for Scope 2" }
                        ]
                    },
                    {
                        "answer_id": 0.25,
                        "answer_label": "Select the number of past reporting years you will be providing Scope 3 emissions data for*",
                        "answer_description": "select in any option",
                        "answer_type": "radio",
                        "answer_name": "answer_0.25",
                        "answer_options": [
                            { "key": "1year", "value": "1 Year" },
                            { "key": "2years", "value": "2 Years" },
                            { "key": "3years", "value": "3 Years" },
                            { "key": "4years", "value": "4 Years" },
                            { "key": "5years", "value": "5 Years" },
                            { "key": "Null", "value": "Not providing past emissions data for Scope 3" }
                        ]
                    },
                ]
            },
            {
                "id": 0.3,
                "field_label": "Select the countries/areas in which you operate.",
                "field_name": "(C0.3)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 0.30,
                        "answer_label": "Country/area",
                        "answer_description": "select all that apply",
                        "answer_type": "dropdown",
                        "answer_name": "country_0.30",
                        "answer_options": [
                            { "key": "us", "value": "USA" },
                            { "key": "ca", "value": "Canada" },
                            { "key": "uk", "value": "UK" }
                        ]
                    },
                ]
            },
            {
                "id": 0.4,
                "field_label": "Select the currency used for all financial information disclosed throughout your response.",
                "field_name": "(C0.4)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 0.40,
                        "answer_label": "Currency",
                        "answer_description": "select all that apply",
                        "answer_type": "dropdown",
                        "answer_name": "currency_0.40",
                        "answer_options": [
                            { "key": "usd", "value": "USD" },
                            { "key": "inr", "value": "INR" },
                            { "key": "eur", "value": "EUR" }
                        ]
                    },
                ]
            },
            {
                "id": 0.5,
                "field_label": "Select the option that describes the reporting  boundary for which climate-related impacts on your business are being reported.  Note that this option should align with your chosen approach for consolidating your GHG inventory.",
                "field_name": "(C0.5)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 0.50,
                        "answer_label": "Select one of the following options:",
                        "answer_description": "select in any option",
                        "answer_type": "radio",
                        "answer_name": "answer_0.50",
                        "answer_options": [
                            { "key": "financial_control", "value": "Financial control" },
                            { "key": "operational_control", "value": "Operational control" },
                            { "key": "equity_share", "value": "Equity share" },
                            { "key": "other_please_specify", "value": "Other, please specify" },
                        ]
                    },
                ]
            },
            {
                "id": 0.7,
                "field_label": "Which part of the electric utilities value chain does your organization operate in? Select all that apply..",
                "field_name": "(C0.7)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 0.70,
                        "answer_label": "Electric utilities value chain",
                        "answer_description": " Electric utilities value chain",
                        "answer_type": "checkbox",
                        "answer_name": "answer_0.70",
                        "answer_options": [
                            { "key": "electricity generation ", "value": "Electricity generation " },
                            { "key": "transmission", "value": "Transmission" },
                            { "key": "distribution", "value": "Distribution" },

                        ]
                    },
                    {
                        "answer_id": 0.71,
                        "answer_label": "other divisions",
                        "answer_description": "Other divisions ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_0.71",
                        "answer_options": [
                            //{ "key": "gas_storage_transmission_and_distribution", "value": "Gas storage transmission and distribution" },
                            { "key": "smart grids / demand response ", "value": "Smart grids / demand response " },
                            { "key": "battery_storage ", "value": "Battery storage " },
                            { "key": "microgrids ", "value": "Microgrids " },
                            { "key": "coal mining ", "value": "Coal mining " },
                            { "key": "gas_extraction_and_production  ", "value": "Gas extraction and production " },


                        ]
                    },
                ]
            },
            {
                "id": 0.8,
                "field_label": " Does your organization have an ISIN code or another unique identifier (e.g., Ticker, CUSIP, etc.)? ",
                "field_name": "(C0.8)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 0.80,
                        "answer_label": "Indicate whether you are able to provide a unique identifier for your organization",
                        "answer_description": " Indicate whether you are able to provide a unique identifier for your organization",
                        "answer_type": "checkbox",
                        "answer_name": "answer_0.80",
                        "answer_options": [
                            { "key": " yes an ISIN code", "value": "Yes an ISIN code" },
                            //{ "key": "yes an ISIN code", "value ": "Yes an ISIN code" },
                            { "key": " yes a CUSIP number ", "value": "Yes a CUSIP number" },
                            { "key": " yes a Ticker symbol  ", "value": "Yes a Ticker symbol " },
                            { "key": " yes a SEDOL code   ", "value": "Yes a SEDOL code  " },
                            {
                                "key": "  yes another unique identifier please specify  ",
                                "value": "  Yes another unique identifier please specify  "
                            },
                            { "key": "  no ", "value": "  No " },

                        ]
                    },
                    {
                        "answer_id": 0.81,
                        "answer_label": "Provide your unique identifier*",
                        "answer_description": "Provide your unique Identifier ",
                        "answer_type": "textarea",
                        "answer_name": "answer_0.81",
                        "answer_options": []
                    }
                ]

            },
            {
                "id": 1,
                "field_label": "C1 Governance",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 1.1,
                "field_label": "Is there board-level oversight of climate-related issues within your organization? ",
                "field_name": "(C1.1)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 1.1,
                        "answer_label": "Select one of the following options: ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_0.1",
                        "answer_options": [
                            { "key": "yes ", "value": "Yes " },
                            { "key": "no", "value": "No" },
                        ]
                    }
                ]
            },
            {
                "id": '1.1a',
                "field_label": "Which part of the electric utilities value chain does your organization operate in? Select all that apply..",
                "field_name": "(C1.1a)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.1a',
                        "answer_label": "Select from: ",
                        "answer_description": "Select from: ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_1.1a",
                        "answer_options": [
                            { "key": "board Chair  ", "value": " Board Chair  " },
                            { "key": "director on board", "value": "Director on Board" },
                            { "key": "cheif executive officer (ceo)", "value": "Chief Executive Officer (CEO)" },
                            { "key": "cheif financial officer (cfo)", "value": "Chief Financial Officer (CFO)" },
                            { "key": "cheif operating officer (coo)", "value": "Chief Operating Officer (COO)" },
                            { "key": "cheif procurement officer (cpo)", "value": "Chief Procurement Officer (CPO)" },
                            { "key": "cheif risk officer (cro)", "value": "Chief Risk Officer (CRO)" },
                            { "key": "cheif sustainability officer (cso)", "value": "Chief Sustainability Officer (CSO)" },
                            { "key": "cheif investment officer (cio)", "value": "Chief Investment Officer (CIO)" },
                            { "key": "cheif credit officer (cco)", "value": "Chief Credit Officer (CCO)" },
                            { "key": "cheif underwritting officer (cuo)", "value": "Chief Underwritting Officer (CUO)" },
                            { "key": "cheif government realation officer (cgro)", "value": "Chief Government Realation Officer (CGRO)" },
                            { "key": "cheif technology officer (cto)", "value": "Chief Technology Officer (CTO)" },
                            { "key": "other c-suite  officer ", "value": "Other C-Suite Officer " },
                            { "key": "president", "value": "President" },
                            { "key": "board level committee", "value": "Board Level Committee" },
                            { "key": "general counsel", "value": "General Counsel" },
                            { "key": "other  please specify", "value": "Other  Please Specify" },



                        ]
                    },

                ]
            },
            {
                "id": '1.1b',
                "field_label": "Frequency with which climate-related issues are a scheduled agenda item.",
                "field_name": "(C1.1b)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.1b0',
                        "answer_label": "Select from: ",
                        "answer_description": "Select from: ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_1.1b0",
                        "answer_options": [
                            { "key": "scheduled - all meetings ", "value": "Scheduled - all meetings " },
                            { "key": "scheduled - some meetings ", "value": "Scheduled - some meetings " },
                            { "key": "sporadic - as important matters   arise ", "value": "Sporadic - as important matters   arise " },
                            { "key": "other please specify ", "value": "Other please specify " },

                        ]
                    },
                    {
                        "answer_id": '1.1b1',
                        "answer_label": "Governance mechanisms into which climate-related issues are integrated ",
                        "answer_description": "select any that apply",
                        "answer_type": "dropdown",
                        "answer_name": "answer_1.1b1",
                        "answer_options": [
                            { "key": "Reviewing and guiding annual budgets ", "value": "Reviewing and guiding annual budgets " },
                            { "key": "Overseeing major capital expenditures ", "value": "Overseeing major capital expenditures " },
                            { "key": "Overseeing acquisitions mergers and divestitures ", "value": "Overseeing acquisitions mergers and divestitures " },
                            { "key": "Reviewing innovation/R&D priorities ", "value": "Reviewing innovation/R&D priorities " },
                            { "key": "Overseeing and guiding employee incentives ", "value": "Overseeing and guiding employee incentives " },
                            { "key": "Reviewing and guiding strategy ", "value": "Reviewing and guiding strategy " },
                            { "key": "Overseeing and guiding the development of a transition plan ", "value": "Overseeing and guiding the development of a transition plan " },
                            { "key": "Monitoring the implementation of a transition plan  ", "value": "Monitoring the implementation of a transition plan  " },
                            { "key": "Monitoring progress towards corporate targets", "value": "Monitoring progress towards corporate targets " },
                            { "key": "Overseeing and guiding public policy engagement ", "value": "Overseeing and guiding public policy engagement " },
                            { "key": "Overseeing value chain engagement ", "value": "Overseeing value chain engagement " },
                            { "key": "Reviewing and guiding the risk management process ", "value": "Reviewing and guiding the risk management process " },
                            { "key": "other please specify", "value": "Other please specify" }
                        ]
                    },
                    {
                        "answer_id": '1.1b2',
                        "answer_label": "[FINANCIAL SERVICES ONLY] Scope of board-level oversight ",
                        "answer_description": "select any that apply",
                        "answer_type": "dropdown",
                        "answer_name": "answer_1.1b2",
                        "answer_options": [
                            { "key": "climate-related risks and opportunities to our own operations ", "value": "Climate-related risks and opportunities to our own operations " },
                            { "key": "climate-related risks and opportunities to our banking activities", "value": "Climate-related risks and opportunities to our banking activities" },
                            { "key": "climate-related risks and opportunities to our investment activities ", "value": "Climate-related risks and opportunities to our investment activities " },
                            { "key": "climate-related risks and opportunities to our insurance underwriting activities ", "value": "Climate-related risks and opportunities to our insurance underwriting activities " },
                            { "key": "the impact of our own operations on the climate ", "value": "The impact of our own operations on the climate " },
                            { "key": "the impact of our banking activities on the climate ", "value": "The impact of our banking activities on the climate " },
                            { "key": "the impact of our investing activities on the climate ", "value": "The impact of our investing activities on the climate " },
                            { "key": "the impact of our insurance underwriting activities on the climate ", "value": "The impact of our insurance underwriting activities on the climate " }
                        ]
                    },
                    {
                        "answer_id": '1.1b3',
                        "answer_label": "Please explain ",
                        "answer_description": "",
                        "answer_type": "text",
                        "answer_name": "answer_1.1b3",
                        "answer_options": [

                        ]
                    },


                ]
            },
            {
                "id": '1.1c',
                "field_label": "Why is there no board-level oversight of climate-related issues and what are your plans to change this in the future? ",
                "field_name": "(C1.1c)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.1c0',
                        "answer_label": "Primary Reason ",
                        "answer_description": "Select from: ",
                        "answer_type": "text",
                        "answer_name": "answer_1.1c0",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.1c1',
                        "answer_label": "Board-level oversight of climate-related issues will be introduced within the next two years.  ",
                        "answer_description": "select any that apply",
                        "answer_type": "dropdown",
                        "answer_name": "answer_1.1c1",
                        "answer_options": [
                            { "key": "yes, we plan to do so within the next two years  ", "value": "Yes, we plan to do so within the next two years  " },
                            { "key": "no, we do not currently plan to do so  ", "value": "No, we do not currently plan to do so                            " },

                        ]
                    },

                    {
                        "answer_id": '1.1c3',
                        "answer_label": "Please explain ",
                        "answer_description": "",
                        "answer_type": "text",
                        "answer_name": "answer_1.1c3",
                        "answer_options": [

                        ]
                    },


                ]
            },
            {
                "id": 1.3,
                "field_label": "Do you provide incentives for the management of climate-related issues, including the attainment of targets?  ",
                "field_name": "(C1.3)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 1.30,
                        "answer_label": "Provide incentives for the management of climate-related issues  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_1.30",
                        "answer_options": [
                            { "key": "yes ", "value": "Yes " },
                            { "key": "no, not currently but we plan to introduce them in the next two years", "value": "No, not currently but we plan to introduce them in the next two years" },
                            { "key": "no, and we do not plan to introduce them in the next two years  			 ", "value": "No, and we do not plan to introduce them in the next two years  			 " },
                        ]
                    },
                    {
                        "answer_id": 1.31,
                        "answer_label": "Comment ",
                        "answer_description": " ",
                        "answer_type": "text",
                        "answer_name": "answer_1.31",
                        "answer_options": [

                        ]
                    }
                ]
            },
            {
                "id": '1.3a',
                "field_label": " Provide further details on the incentives provided for the management of climate-related issues (do not include the names of individuals).  ",
                "field_name": "(C1.3a)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.3a0',
                        "answer_label": "Entitled to incentive  ",
                        "answer_description": "Select from: ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_1.3a0",
                        "answer_options": [
                            { "key": "board Chair  ", "value": " Board Chair  " },
                            { "key": "director on board", "value": "Director on Board" },
                            { "key": "cheif executive officer (ceo)", "value": "Chief Executive Officer (CEO)" },
                            { "key": "cheif financial officer (cfo)", "value": "Chief Financial Officer (CFO)" },
                            { "key": "cheif operating officer (coo)", "value": "Chief Operating Officer (COO)" },
                            { "key": "cheif procurement officer (cpo)", "value": "Chief Procurement Officer (CPO)" },
                            { "key": "cheif risk officer (cro)", "value": "Chief Risk Officer (CRO)" },
                            { "key": "cheif sustainability officer (cso)", "value": "Chief Sustainability Officer (CSO)" },
                            { "key": "cheif investment officer (cio)", "value": "Chief Investment Officer (CIO)" },
                            { "key": "cheif credit officer (cco)", "value": "Chief Credit Officer (CCO)" },
                            { "key": "cheif underwritting officer (cuo)", "value": "Chief Underwritting Officer (CUO)" },
                            { "key": "cheif government realation officer (cgro)", "value": "Chief Government Realation Officer (CGRO)" },
                            { "key": "cheif technology officer (cto)", "value": "Chief Technology Officer (CTO)" },
                            { "key": "other c-suite  officer ", "value": "Other C-Suite Officer " },
                            { "key": "president", "value": "President" },
                            { "key": "board level committee", "value": "Board Level Committee" },
                            { "key": "general counsel", "value": "General Counsel" },
                            { "key": "other  please specify", "value": "Other  Please Specify" },
                        ]
                    },
                    {
                        "answer_id": '1.3a1',
                        "answer_label": "Type of incentive  ",
                        "answer_description": "select any that apply",
                        "answer_type": "dropdown",
                        "answer_name": "answer_1.3a1",
                        "answer_options": [
                            { "key": "Monetary reward   ", "value": "Monetary reward   " },
                            { "key": "non-Monetary reward  ", "value": "Non-Monetary reward    " },

                        ]
                    },

                    {
                        "answer_id": '1.3a2',
                        "answer_label": "Incentive(s)  ",
                        "answer_description": "",
                        "answer_type": "text",
                        "answer_name": "answer_1.3a2",
                        "answer_options": [
                            { "key": "bonus - % of salary    ", "value": "Bonus - % of salary   " },
                            { "key": "bonus – set figure  ", "value": "Bonus – set figure    " },
                            { "key": "promotion    ", "value": "Promotion   " },
                            { "key": "salary increased ", "value": "Salary increased   " },
                            { "key": "retirement plan    ", "value": "Retirement plan   " },
                            { "key": "internal company award ", "value": "Internal company award   " },
                            { "key": "internal team/employee of the month/quarter/year recognition   ", "value": "Internal team/employee of the month/quarter/year recognition  " },
                            { "key": "public recognition   ", "value": "Public recognition    " },
                        ]
                    },
                    {
                        "answer_id": '1.3a3',
                        "answer_label": "Performance indicator(s)   ",
                        "answer_description": "select any that apply",
                        "answer_type": "dropdown",
                        "answer_name": "answer_1.3a3",
                        "answer_options": [
                            { "key": "Board approval of climate transition plan   ", "value": "Board approval of climate transition plan   " },
                            { "key": "Shareholder approval of climate transition plan  ", "value": "Shareholder approval of climate transition plan  " },
                            { "key": "Achievement of climate transition plan KPI   ", "value": "Achievement of climate transition plan KPI  " },
                            { "key": "Progress towards a climate-related target  ", "value": "Progress towards a climate-related target  " },
                            { "key": "Achievement of a climate-related target  ", "value": "Achievement of a climate-related target " },
                            { "key": "Implementation of an emissions reduction initiative  ", "value": "Implementation of an emissions reduction initiative " },
                            { "key": "Reduction in absolute emissions   ", "value": "Reduction in absolute emissions  " },
                            { "key": "Increased share of revenue from low-carbon products or services in product or service portfolio   ", "value": "Increased share of revenue from low-carbon products or services in product or service portfolio  " },
                            { "key": "Increased engagement with investee companies on climate-related issues [Financial Services only] ", "value": "Increased engagement with investee companies on climate-related issues [Financial Services only] " },
                            { "key": "Increased value chain visibility (traceability, mapping, transparency)  ", "value": "Increased value chain visibility (traceability, mapping, transparency)   " },
                            { "key": "Company performance against a climate-related sustainability index (e.g., DJSI, CDP Climate Change score etc.)   ", "value": "Company performance against a climate-related sustainability index (e.g., DJSI, CDP Climate Change score etc.) " },
                            { "key": "Implementation of employee awareness campaign or training program on climate-related issues   ", "value": "Implementation of employee awareness campaign or training program on climate-related issues " },
                            { "key": "Increased alignment of portfolio/fund to climate-related objectives [Financial Services only]  ", "value": "Increased alignment of portfolio/fund to climate-related objectives [Financial Services only]   " },



                        ]
                    },
                    {
                        "answer_id": '1.3a4',
                        "answer_label": "Incentive plan(s) this incentive is linked to   ",
                        "answer_description": "select any that apply",
                        "answer_type": "dropdown",
                        "answer_name": "answer_1.3a4",
                        "answer_options": [
                            { "key": "short-Term Incentive Plan   ", "value": "Short-Term Incentive Plan   " },
                            { "key": "long-Term Incentive Plan ", "value": "Long-Term Incentive Plan " },
                            { "key": "both Short-Term and Long-Term Incentive Plan  ", "value": "Both Short-Term and Long-Term Incentive Plan   " },
                            { "key": "not part of an existing incentive plan   ", "value": "Not part of an existing incentive plan " },
                            { "key": "not part of an existing incentive plan  ", "value": "Not part of an existing incentive plan  " },



                        ]
                    },
                    {
                        "answer_id": '1.3a5',
                        "answer_label": "Further details of incentive(s)   ",
                        "answer_description": "select any that apply",
                        "answer_type": "text",
                        "answer_name": "answer_1.3a5",
                        "answer_options": [


                        ]
                    },
                    {
                        "answer_id": '1.3a6',
                        "answer_label": "Explain how this incentive contributes to the implementation of your organization’s climate commitments and/or climate transition plan   ",
                        "answer_description": "select any that apply",
                        "answer_type": "text",
                        "answer_name": "answer_1.3a6",
                        "answer_options": [


                        ]
                    },


                ]
            },
            {
                "id": 2,
                "field_label": "C2 Risks and opportunities ",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 2.1,
                "field_label": "Does your organization have a process for identifying, assessing, and responding to climate-related risks and opportunities?  ",
                "field_name": "(C2.1)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 2.1,
                        "answer_label": "Select one of the following options: ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_2.1",
                        "answer_options": [
                            { "key": "yes ", "value": "Yes " },
                            { "key": "no", "value": "No" },
                        ]
                    }
                ]
            },
            {
                "id": '2.1a',
                "field_label": "Why is there no board-level oversight of climate-related issues and what are your plans to change this in the future? ",
                "field_name": "(C2.1a)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.1a0',
                        "answer_label": "Time horizon  ",
                        "answer_description": "Select from: ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_2.1a0",
                        "answer_options": [
                            { "key": "short-term  ", "value": "Short-term  " },
                            { "key": "middle-term   ", "value": "Middle-term  " },
                            { "key": "long-term   ", "value": "Long-term  " },
                        ]
                    },
                    {
                        "answer_id": '2.1a1',
                        "answer_label": "From (years)   ",
                        "answer_description": "select any that apply",
                        "answer_type": "number",
                        "answer_name": "answer_2.1a1",
                        "answer_options": [


                        ]
                    },

                    {
                        "answer_id": '2.1a2',
                        "answer_label": "To (years) ",
                        "answer_description": "",
                        "answer_type": "number",
                        "answer_name": "answer_2.1a2",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.1a3',
                        "answer_label": "Comments ",
                        "answer_description": "Comment",
                        "answer_type": "Text",
                        "answer_name": "answer_2.1a3",
                        "answer_options": [

                        ]
                    },


                ]
            },
            {
                "id": '2.1b',
                "field_label": " How does your organization define substantive financial or strategic impact on your business?  ",
                "field_name": "(C2.1b)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.1b0',
                        "answer_label": "Time horizon  ",
                        "answer_description": " ",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.1b0",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": 2.2,
                "field_label": "Describe your process(es) for identifying, assessing and responding to climate-related risks and opportunities.   ",
                "field_name": "(C2.2)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 2.20,
                        "answer_label": "value chain stage(s) covered  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_2.20",
                        "answer_options": [
                            { "key": "direct operation ", "value": "Direct Operation " },
                            { "key": "upstream", "value": "Upstream" },
                            { "key": "downstream ", "value": "Downstream" },
                        ]
                    },
                    {
                        "answer_id": 2.21,
                        "answer_label": "Risk management process  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_2.21",
                        "answer_options": [
                            { "key": "integrated into multi-disciplinary company-wide risk management process  ", "value": "Integrated into multi-disciplinary company-wide risk management process  " },
                            { "key": "integrated into multi-disciplinary company-wide risk management process ", "value": "Integrated into multi-disciplinary company-wide risk management process " },
                        ]
                    },
                    {
                        "answer_id": 2.22,
                        "answer_label": "Frequency of assessment  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_2.22",
                        "answer_options": [
                            { "key": "more than once a year ", "value": "More than once a year " },
                            { "key": "annually ", "value": "Annually " },
                            { "key": "every two years  ", "value": "Every two years  " },
                            { "key": "every three years or more ", "value": "Every three years or more " },
                        ]
                    },
                    {
                        "answer_id": 2.23,
                        "answer_label": "Time horizon(s) covered  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_2.23",
                        "answer_options": [
                            { "key": "Short-term  ", "value": "Short-term  " },
                            { "key": "Medium-term ", "value": "Medium-term " },
                            { "key": "Long-term  ", "value": "Long-term  " },
                            { "key": "None of the above/Not defined  ", "value": "None of the above/Not defined  " },
                        ]
                    },
                    {
                        "answer_id": 2.24,
                        "answer_label": "Description of process  ",
                        "answer_description": "",
                        "answer_type": "text",
                        "answer_name": "answer_2.24",
                        "answer_options": [

                        ]
                    }
                ]
            },
            {
                "id": 3,
                "field_label": "C3 Business strategy ",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 3.1,
                "field_label": "Does your organization’s strategy include a climate transition plan that aligns with a 1.5°C world?   ",
                "field_name": "(C3.1)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 3.10,
                        "answer_label": "Climate transition plan  ",
                        "answer_description": " ",
                        "answer_type": "radio",
                        "answer_name": "answer_3.10",
                        "answer_options": [
                            { "key": "yes, we have a climate transition plan which aligns with a 1.5°C world  ", "value": "Yes, we have a climate transition plan which aligns with a 1.5°C world  " },
                            { "key": "no, but our strategy has been influenced by climate-related risks and opportunities, and we are developing a climate transition plan within two year", "value": "No, but our strategy has been influenced by climate-related risks and opportunities, and we are developing a climate transition plan within two year" },
                            { "key": "no, our strategy has been influenced by climate-related risks and opportunities, but we do not plan to develop a climate transition plan within two years  ", "value": "No, our strategy has been influenced by climate-related risks and opportunities, but we do not plan to develop a climate transition plan within two years  " },
                            { "key": "no, and our strategy has not been influenced by climate-related risks and opportunities ", "value": "No, and our strategy has not been influenced by climate-related risks and opportunities " },

                        ]
                    },
                    {
                        "answer_id": 3.11,
                        "answer_label": "Publicly available climate transition plan  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_3.11",
                        "answer_options": [
                            { "key": "yes ", "value": "Yes " },
                            { "key": "no", "value": "No" },
                        ]
                    },
                    {
                        "answer_id": 3.12,
                        "answer_label": "Mechanism by which feedback is collected from shareholders on your climate transition plan  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_3.12",
                        "answer_options": [
                            { "key": "our climate transition plan is voted on at Annual General Meetings (AGMs) ", "value": "Our climate transition plan is voted on at Annual General Meetings (AGMs) " },
                            { "key": "we have a different feedback mechanism in place ", "value": "We have a different feedback mechanism in place " },
                            { "key": "our climate transition plan is voted on at AGMs and we also have an additional feedback mechanism in place  ", "value": "Our climate transition plan is voted on at AGMs and we also have an additional feedback mechanism in place " },
                            { "key": "we do not have a feedback mechanism in place, but we plan to introduce one within the next two years  ", "value": "We do not have a feedback mechanism in place, but we plan to introduce one within the next two years  " },
                            { "key": "we do not have a feedback mechanism in place, and we do not plan to introduce one within the next two years  ", "value": "We do not have a feedback mechanism in place, and we do not plan to introduce one within the next two years  " },
                        ]
                    },
                    {
                        "answer_id": 3.13,
                        "answer_label": "Description of feedback mechanism  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "text",
                        "answer_name": "answer_3.13",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": 3.14,
                        "answer_label": "Frequency of feedback collection  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_3.14",
                        "answer_options": [
                            { "key": "more frequently than annually ", "value": "More frequently than annually  " },
                            { "key": "anually", "value": "Anually" },
                            { "key": "less frequently than annually", "value": "Less frequently than annually" },
                        ]
                    },
                    {
                        "answer_id": 3.15,
                        "answer_label": "Attach any relevant documents which detail your climate transition plan (optional)  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "file",
                        "answer_name": "answer_3.15",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": 3.16,
                        "answer_label": "Explain why your organization does not have a climate transition plan that aligns with a 1.5°C world and any plans to develop one in the future  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "text",
                        "answer_name": "answer_3.16",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": 3.17,
                        "answer_label": "Explain why climate-related risks and opportunities have not influenced your strategy  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "text",
                        "answer_name": "answer_3.17",
                        "answer_options": [

                        ]
                    }
                ]
            },





            /////////////
            {
                "id": 7,
                "field_label": "C7 Emissions breakdown",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 7.1,
                "field_label": "Does your organization break down its Scope 1 emissions by greenhouse gas type?",
                "field_name": "(C7.1)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 7.10,
                        "answer_label": "Select one of the following options:",
                        "answer_description": "select in any option",
                        "answer_type": "radio",
                        "answer_name": "answer_7.10",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                            { "key": "don't_know", "value": "Don't Know" },
                        ]
                    },
                ]
            },
            {
                "id": '7.1a',
                "field_label": "Break down your total gross global Scope 1 emissions by greenhouse gas type and provide the source of each used global warming potential (GWP).",
                "field_name": "(C7.1a)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '7.1a0',
                        "answer_label": "Greenhouse gas",
                        "answer_description": "select any that apply",
                        "answer_type": "dropdown",
                        "answer_name": "greenhouse_gas_7.1a0",
                        "answer_options": [
                            { "key": "co2", "value": "CO2" },
                            { "key": "ch4", "value": "CH4" },
                            { "key": "n2o", "value": "N2O" },
                            { "key": "hfcs", "value": "HFCs" },
                            { "key": "pfcs", "value": "PFCs" },
                            { "key": "sf6", "value": "SF6" },
                            { "key": "nf3", "value": "NF3" },
                            { "key": "other", "value": "Other, please specify" }
                        ]
                    },
                    {
                        "answer_id": '7.1a1',
                        "answer_label": "Scope 1 emissions (metric tons in CO2e)",
                        "answer_description": "Numerical   field [enter a range of 0-999,999,999,999 using a maximum of 3 decimal places and no commas]",
                        "answer_type": "number",
                        "answer_name": "answer_7.1a1",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.1a2',
                        "answer_label": "GWP Reference",
                        "answer_description": "select any that apply",
                        "answer_type": "dropdown",
                        "answer_name": "gwp_reference_7.1a2",
                        "answer_options": [
                            { "key": "AR6_100", "value": "IPCC Sixth Assessment Report (AR6 - 100 year)" },
                            { "key": "AR5_100", "value": "IPCC Fifth Assessment Report (AR5 - 100 year)" },
                            { "key": "AR4_100", "value": "IPCC Fourth Assessment Report (AR4 - 100 year)" },
                            { "key": "TAR_100", "value": "IPCC Third Assessment Report (TAR - 100 year)" },
                            { "key": "SAR_100", "value": "IPCC Second Assessment Report (SAR - 100 year)" },
                            { "key": "AR4_50", "value": "IPCC Fourth Assessment Report (AR4 - 50 year)" },
                            { "key": "TAR_50", "value": "IPCC Third Assessment Report (TAR - 50 year)" },
                            { "key": "SAR_50", "value": "IPCC Second Assessment Report (SAR - 50 year)" },
                            { "key": "AR6_20", "value": "IPCC Sixth Assessment Report (AR6 – 20 year)" },
                            { "key": "AR5_20", "value": "IPCC Fifth Assessment Report (AR5 – 20 year)" },
                            { "key": "AR4_20", "value": "IPCC Fourth Assessment Report (AR4 - 20 year)" },
                            { "key": "TAR_20", "value": "IPCC Third Assessment Report (TAR - 20 year)" },
                            { "key": "SAR_20", "value": "IPCC Second Assessment Report (SAR - 20 year)" },
                            { "key": "other", "value": "Other, please specify" }
                        ]
                    },
                ]
            },
            {
                "id": 7.2,
                "field_label": "Break down your total gross global Scope 1 emissions by country/area/region.",
                "field_name": "(C7.2)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 7.20,
                        "answer_label": "Country",
                        "answer_description": "select that apply",
                        "answer_type": "dropdown",
                        "answer_name": "country_7.20",
                        "answer_options": [
                            { "key": "us", "value": "USA" },
                            { "key": "ca", "value": "Canada" },
                            { "key": "uk", "value": "UK" }
                        ]
                    },
                    {
                        "answer_id": 7.21,
                        "answer_label": "Area",
                        "answer_description": "select that apply",
                        "answer_type": "dropdown",
                        "answer_name": "area_7.21",
                        "answer_options": [
                            { "key": "us", "value": "USA" },
                            { "key": "ca", "value": "Canada" },
                            { "key": "uk", "value": "UK" }
                        ]
                    },
                    {
                        "answer_id": 7.22,
                        "answer_label": "Region",
                        "answer_description": "select that apply",
                        "answer_type": "dropdown",
                        "answer_name": "region_7.22",
                        "answer_options": [
                            { "key": "us", "value": "USA" },
                            { "key": "ca", "value": "Canada" },
                            { "key": "uk", "value": "UK" }
                        ]
                    },
                    {
                        "answer_id": 7.23,
                        "answer_label": "Scope 1 emissions (metric tons CO2e)",
                        "answer_description": "",
                        "answer_type": "number",
                        "answer_name": "answer_7.23",
                        "answer_options": []
                    }

                ]
            },
            {
                "id": 7.3,
                "field_label": "Indicate which gross global Scope 1 emissions breakdowns you are able to provide.",
                "field_name": "(C7.3)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 7.30,
                        "answer_label": "Select all that apply from the following options:",
                        "answer_description": "Select all that apply from the following options:",
                        "answer_type": "checkbox",
                        "answer_name": "answer_7.30",
                        "answer_options": [
                            { "key": "businessDivision", "value": "By business division" },
                            { "key": "facility", "value": "By facility" },
                            { "key": "activity", "value": "By activity" }

                        ]
                    }
                ]
            },
            {
                "id": '7.3a',
                "field_label": "Break down your total gross global Scope 1 emissions by business division.",
                "field_name": "(C7.3a)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '7.3a0',
                        "answer_label": "Business division",
                        "answer_description": "Text field [maximum 500 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_7.3a0",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.3a1',
                        "answer_label": "Scope 1 emissions (metric tons CO2e)",
                        "answer_description": "Numerical field [enter a range of 0- 999,999,999,999 using a maximum of 3 decimal places and no commas]",
                        "answer_type": "number",
                        "answer_name": "answer_7.3a1",
                        "answer_options": []
                    }
                ]
            },
            {
                "id": '7.3b',
                "field_label": "Break down your total gross global Scope 1 emissions by business facility.",
                "field_name": "(C7.3b)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '7.3b0',
                        "answer_label": "Facility",
                        "answer_description": "Text field [maximum 500 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_7.3b0",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.3b1',
                        "answer_label": "Scope 1 emissions (metric tons CO2e)",
                        "answer_description": "Numerical field [enter a range of 0- 999,999,999,999 using a maximum of 3 decimal places and no commas]",
                        "answer_type": "number",
                        "answer_name": "answer_7.3b1",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.3b2',
                        "answer_label": "Latitude",
                        "answer_description": "Enter the latitude of your facility here using numbers between 90.000000   and -90.000000, e.g. 51.524810",
                        "answer_type": "number",
                        "answer_name": "answer_7.3b2",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.3b3',
                        "answer_label": "Longitude",
                        "answer_description": "Enter the longitude of your facility using numbers between 180.000000   and  -180.000000, e.g. -0.106958",
                        "answer_type": "number",
                        "answer_name": "answer_7.3b3",
                        "answer_options": []
                    }
                ]
            },
            {
                "id": '7.3c',
                "field_label": "Break down your total gross global Scope 1 emissions by business activity.",
                "field_name": "(C7.3c)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '7.3c0',
                        "answer_label": "Activity",
                        "answer_description": "Text field [maximum 500 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_7.3c0",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.3c1',
                        "answer_label": "Scope 1 emissions (metric tons CO2e)",
                        "answer_description": "Numerical field [enter a range of 0-999,999,999,999 using a maximum of 3 decimal places and no commas]",
                        "answer_type": "number",
                        "answer_name": "answer_7.3c1",
                        "answer_options": []
                    }
                ]
            },
            {
                "id": 7.7,
                "field_label": "Is your organization able to break down your emissions data for any of the subsidiaries included in your CDP response?",
                "field_name": "(C7.7)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 7.70,
                        "answer_label": "Select one of the following options:",
                        "answer_description": "select any option",
                        "answer_type": "radio",
                        "answer_name": "answer_7.70",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                            { "key": "not_relevant", "value": "Not relevant as we do not have any subsidiaries" },
                        ]
                    },
                ]
            },
            {
                "id": '7.7a',
                "field_label": "Break down your gross Scope 1 and Scope 2 emissions by subsidiary.",
                "field_name": "(C7.7a)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '7.7a0',
                        "answer_label": "Subsidiary name",
                        "answer_description": "Text field [maximum 200 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_7.7a0",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.7a1',
                        "answer_label": "Primary activity",
                        "answer_description": "select that apply",
                        "answer_type": "dropdown",
                        "answer_name": "primary_activity_7.7a1",
                        "answer_options": [
                            { "key": "cdp", "value": "CDP" },
                            { "key": "acs", "value": "ACS" },
                        ]
                    },
                    {
                        "answer_id": '7.7a2',
                        "answer_label": "Select the unique identifier(s) you are able to provide for this subsidiary",
                        "answer_description": "Select all that apply",
                        "answer_type": "checkbox",
                        "answer_name": "answer_7.7a2",
                        "answer_options": [
                            { "key": "ISINBond", "value": "ISIN code - bond" },
                            { "key": "ISINEquity", "value": "ISIN code - equity" },
                            { "key": "CUSIP", "value": "CUSIP number" },
                            { "key": "TickerSymbol", "value": "Ticker symbol" },
                            { "key": "SEDOL", "value": "SEDOL code" },
                            { "key": "LEI", "value": "LEI number" },
                            { "key": "AnotherIdentifier", "value": "Another unique identifier, please specify" },
                            { "key": "NoIdentifier", "value": "No unique identifier" }
                        ]
                    },
                    {
                        "answer_id": '7.7a3',
                        "answer_label": "ISIN code - bond*",
                        "answer_description": "Text field [maximum 12 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_7.7a3",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.7a4',
                        "answer_label": "ISIN code - equity*",
                        "answer_description": "Text field [maximum 12 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_7.7a4",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.7a5',
                        "answer_label": "CUSIP number*",
                        "answer_description": "Text field [maximum 9 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_7.7a5",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.7a6',
                        "answer_label": "Ticker symbol*",
                        "answer_description": "Text field [maximum 5 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_7.7a6",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.7a7',
                        "answer_label": "SEDOL code*",
                        "answer_description": "Text field [maximum 7 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_7.7a7",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.7a8',
                        "answer_label": "LEI number*",
                        "answer_description": "Text field [maximum 20 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_7.7a8",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.7a9',
                        "answer_label": "Other unique identifier*",
                        "answer_description": "Text field [maximum 50 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_7.7a9",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.7a10',
                        "answer_label": "Scope 1 emissions (metric tons CO2e)",
                        "answer_description": "Numerical field [enter a number from 0-99,999,999,999 using a maximum of 3 decimal places and no commas]",
                        "answer_type": "number",
                        "answer_name": "answer_7.7a10",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.7a11',
                        "answer_label": "Scope 2, location-based emissions (metric tons CO2e)",
                        "answer_description": "Numerical field [enter a number from 0-99,999,999,999 using a maximum of 3 decimal places and no commas]",
                        "answer_type": "number",
                        "answer_name": "answer_7.7a11",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.7a12',
                        "answer_label": "Scope 2, market-based emissions (metric tons CO2e)",
                        "answer_description": "Numerical field [enter a number from 0-99,999,999,999 using a maximum of 3 decimal places and no commas]",
                        "answer_type": "number",
                        "answer_name": "answer_7.7a12",
                        "answer_options": []
                    },
                    {
                        "answer_id": '7.7a13',
                        "answer_label": "Comment",
                        "answer_description": "Text field [maximum 2,500 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_7.7a13",
                        "answer_options": []
                    },
                ]
            },
            {
                "id": 7.8,
                "field_label": "only applies to organizations with activities in the following sectors:",
                "field_name": "question_C7.8",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 7.80,
                        "answer_label": "Select one of the following options:",
                        "answer_description": "select any option",
                        "answer_type": "radio",
                        "answer_name": "answer_7.80",
                        "answer_options": [
                            { "key": "chemicals", "value": "Chemicals" },
                            { "key": "transport_manufacturers", "value": "Transport manufacturers" },
                        ]
                    },
                ]
            },
            {
                "id": 7.9,
                "field_label": "How do your gross global emissions (Scope 1 and 2 combined) for the reporting year compare to those of the previous reporting year?",
                "field_name": "(C7.9)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 7.9,
                        "answer_label": "Select one of the following options:",
                        "answer_description": "select any option",
                        "answer_type": "radio",
                        "answer_name": "answer_7.9",
                        "answer_options": [
                            { "key": "Increased", "value": "Increased" },
                            { "key": "Decreased", "value": "Decreased" },
                            { "key": "RemainedSame", "value": "Remained the same overall" },
                            { "key": "FirstYear", "value": "This is our first year of reporting, so we cannot compare to last year" },
                            { "key": "NoData", "value": "We don't have any emissions data" }
                        ]
                    },
                ]
            },
            {
                "id": '7.9b',
                "field_label": "Are your emissions performance calculations in C7.9 and C7.9a based on a location-based Scope 2 emissions figure or a market-based Scope 2 emissions figure?",
                "field_name": "(C7.9b)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '7.9b',
                        "answer_label": "Select one of the following options:",
                        "answer_description": "select any option",
                        "answer_type": "radio",
                        "answer_name": "answer_7.9b",
                        "answer_options": [
                            { "key": "LocationBased", "value": "Location-based" },
                            { "key": "MarketBased", "value": "Market-based" },
                            { "key": "DontKnow", "value": "Don't know" }
                        ]
                    },
                ]
            },
            {
                "id": 8,
                "field_label": "C8 Energy",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": '8.1',
                "field_label": "What percentage of your total operational spend in the reporting year was on energy?",
                "field_name": "(C8.1)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '8.1',
                        "answer_label": "Select one of the following options:",
                        "answer_description": "select any option",
                        "answer_type": "radio",
                        "answer_name": "answer_8.1",
                        "answer_options": [
                            { "key": "0%", "value": "0%" },
                            { "key": "5%", "value": "More than 0% but less than or equal to 5%" },
                            { "key": "10%", "value": "More than 5% but less than or equal to 10%" },
                            { "key": "15%", "value": "More than 10% but less than or equal to 15%" },
                            { "key": "20%", "value": "More than 15% but less than or equal to 20%" },
                            { "key": "25%", "value": "More than 20% but less than or equal to 25%" },
                            { "key": "30%", "value": "More than 25% but less than or equal to 30%" },
                            { "key": "35%", "value": "More than 30% but less than or equal to 35%" },
                            { "key": "40%", "value": "More than 35% but less than or equal to 40%" },
                            { "key": "45%", "value": "More than 40% but less than or equal to 45%" },
                            { "key": "50%", "value": "More than 45% but less than or equal to 50%" },
                            { "key": "55%", "value": "More than 50% but less than or equal to 55%" },
                            { "key": "60%", "value": "More than 55% but less than or equal to 60%" },
                            { "key": "65%", "value": "More than 60% but less than or equal to 65%" },
                            { "key": "70%", "value": "More than 65% but less than or equal to 70%" },
                            { "key": "75%", "value": "More than 70% but less than or equal to 75%" },
                            { "key": "80%", "value": "More than 75% but less than or equal to 80%" },
                            { "key": "85%", "value": "More than 80% but less than or equal to 85%" },
                            { "key": "90%", "value": "More than 85% but less than or equal to 90%" },
                            { "key": "95%", "value": "More than 90% but less than or equal to 95%" },
                            { "key": "100%", "value": "More than 95% but less than or equal to 100%" },
                            { "key": "DontKnow", "value": "Don't know" }
                        ]
                    },
                ]
            },
            {
                "id": '8.2g',
                "field_label": "Provide a breakdown by country/area of your non-fuel energy consumption in the reporting year.",
                "field_name": "(C8.2g)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '8.2g0',
                        "answer_label": "Country/area",
                        "answer_description": "select that apply",
                        "answer_type": "dropdown",
                        "answer_name": "Country/area_8.2g0",
                        "answer_options": [
                            { "key": "us", "value": "USA" },
                            { "key": "ca", "value": "Canada" },
                            { "key": "uk", "value": "UK" }
                        ]
                    },
                    {
                        "answer_id": '8.2g1',
                        "answer_label": "Consumption of purchased electricity (MWh)",
                        "answer_description": "Numerical field [enter a number from 0-999,999,999,999 using a maximum of 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_8.2g1",
                        "answer_options": []
                    },
                    {
                        "answer_id": '8.2g2',
                        "answer_label": "Consumption of self-generated electricity (MWh)",
                        "answer_description": "Numerical field [enter a number from 0-999,999,999,999 using a maximum of 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_8.2g2",
                        "answer_options": []
                    },
                    {
                        "answer_id": '8.2g3',
                        "answer_label": "Is this electricity consumption excluded from your RE100 commitment?*",
                        "answer_description": "select any option",
                        "answer_type": "radio",
                        "answer_name": "answer_8.2g3",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                        ]
                    },
                    {
                        "answer_id": '8.2g4',
                        "answer_label": "Consumption of purchased heat, steam, and cooling (MWh)",
                        "answer_description": "Numerical field [enter a number from 0-999,999,999,999 using a maximum of 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_8.2g4",
                        "answer_options": []
                    },
                    {
                        "answer_id": '8.2g5',
                        "answer_label": "Consumption of self-generated heat, steam, and cooling (MWh)",
                        "answer_description": "Numerical field [enter a number from 0-999,999,999,999 using a maximum of 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_8.2g5",
                        "answer_options": []
                    },
                    {
                        "answer_id": '8.2g6',
                        "answer_label": "Total non-fuel energy consumption (MWh) [Auto-calculated]",
                        "answer_description": "Numerical field [0-999,999,999,999]",
                        "answer_type": "number",
                        "answer_name": "answer_8.2g6",
                        "answer_options": []
                    },
                ]
            },
            {
                "id": 8.4,
                "field_label": "Does your electric utility organization have a transmission and distribution business?",
                "field_name": "(C-EU8.4)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '8.4',
                        "answer_label": "Select one of the following options:",
                        "answer_description": "select any option",
                        "answer_type": "radio",
                        "answer_name": "answer_8.4",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                        ]
                    },
                ]
            },
            {
                "id": '8.4a',
                "field_label": "Disclose the following information about your transmission and distribution business.",
                "field_name": "(C-EU8.4a)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '8.4a0',
                        "answer_label": "Country",
                        "answer_description": "select that apply",
                        "answer_type": "dropdown",
                        "answer_name": "country_8.4a",
                        "answer_options": [
                            { "key": "us", "value": "USA" },
                            { "key": "ca", "value": "Canada" },
                            { "key": "uk", "value": "UK" }
                        ]
                    },
                    {
                        "answer_id": '8.4a1',
                        "answer_label": "Area",
                        "answer_description": "select that apply",
                        "answer_type": "dropdown",
                        "answer_name": "area_8.4a1",
                        "answer_options": [
                            { "key": "us", "value": "USA" },
                            { "key": "ca", "value": "Canada" },
                            { "key": "uk", "value": "UK" }
                        ]
                    },
                    {
                        "answer_id": '8.4a2',
                        "answer_label": "Region",
                        "answer_description": "select that apply",
                        "answer_type": "dropdown",
                        "answer_name": "region_8.4a2",
                        "answer_options": [
                            { "key": "us", "value": "USA" },
                            { "key": "ca", "value": "Canada" },
                            { "key": "uk", "value": "UK" }
                        ]
                    },
                    {
                        "answer_id": '8.4a3',
                        "answer_label": "Voltage level",
                        "answer_description": "select any option",
                        "answer_type": "radio",
                        "answer_name": "answer_8.4a3",
                        "answer_options": [
                            { "key": "Transmission", "value": "Transmission (high voltage)" },
                            { "key": "Distribution", "value": "Distribution (low voltage)" }
                        ]
                    },
                    {
                        "answer_id": '8.4a4',
                        "answer_label": "Annual load (GWh)",
                        "answer_description": "Numerical   field [enter a number from 0 - 999,999 using a maximum of 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_8.4a4",
                        "answer_options": []
                    },
                    {
                        "answer_id": '8.4a5',
                        "answer_label": "Annual energy losses (% of annual load)",
                        "answer_description": "Numerical field [enter a number from 0 - 999,999 using a maximum of 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_8.4a5",
                        "answer_options": []
                    },
                    {
                        "answer_id": '8.4a6',
                        "answer_label": "Scope where emissions from energy losses are accounted for",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_8.4a6",
                        "answer_options": [
                            { "key": "Scope1", "value": "Scope 1" },
                            { "key": "Scope2Location", "value": "Scope 2 (location-based)" },
                            { "key": "Scope2Market", "value": "Scope 2 (market-based)" }
                        ]
                    },

                    {
                        "answer_id": '8.4a7',
                        "answer_label": "Emissions from energy losses (metric tons CO2e)",
                        "answer_description": "Numerical field [enter a number from 0-100 using a maximum of 3 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_8.4a7",
                        "answer_options": []
                    },
                    {
                        "answer_id": '8.4a8',
                        "answer_label": "Length of network (km)",
                        "answer_description": "Numerical field [enter a number from 0-99,999,999,999 using a maximum of 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_8.4a8",
                        "answer_options": []
                    },
                    {
                        "answer_id": '8.4a9',
                        "answer_label": "Number of connections",
                        "answer_description": "Numerical field [enter a number from 0-99,999,999,999 using a maximum of 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_8.4a9",
                        "answer_options": []
                    },
                    {
                        "answer_id": '8.4a10',
                        "answer_label": "Area covered (km2)",
                        "answer_description": "Numerical field [enter a number from 0-99,999,999,999 using a maximum of 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_8.4a10",
                        "answer_options": []
                    },
                    {
                        "answer_id": '8.4a11',
                        "answer_label": "Comment",
                        "answer_description": "Text field [maximum 2,400 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_8.4a11",
                        "answer_options": []
                    },
                ]
            },
            {
                "id": 9,
                "field_label": "C9 Additional metrics",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": '9.1',
                "field_label": "Provide any additional climate-related metrics relevant to your business.",
                "field_name": "(C9.1)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '9.10',
                        "answer_label": "Description",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_9.10",
                        "answer_options": [
                            { "key": "Waste", "value": "Waste" },
                            { "key": "EnergyUsage", "value": "Energy usage" },
                            { "key": "LandUse", "value": "Land use" },
                            { "key": "Other", "value": "Other, please specify" }
                        ]
                    },
                    {
                        "answer_id": '9.11',
                        "answer_label": "Metric value",
                        "answer_description": "Numerical field [enter a number from 0 to 99,999,999,999 using up to 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_9.11",
                        "answer_options": []
                    },
                    {
                        "answer_id": '9.12',
                        "answer_label": "Metric numerator",
                        "answer_description": "Text field [maximum 50 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_9.12",
                        "answer_options": []
                    },
                    {
                        "answer_id": '9.13',
                        "answer_label": "Metric denominator (intensity metric only)",
                        "answer_description": "Text field [maximum 50 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_9.13",
                        "answer_options": []
                    },
                    {
                        "answer_id": '9.14',
                        "answer_label": "% change from previous year",
                        "answer_description": "Numerical field [enter a number from 0 to 999 using up to 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_9.14",
                        "answer_options": []
                    },
                    {
                        "answer_id": '9.15',
                        "answer_label": "Direction of change",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_9.15",
                        "answer_options": [
                            { "key": "Increased", "value": "Increased" },
                            { "key": "Decreased", "value": "Decreased" },
                            { "key": "NoChange", "value": "No change" }
                        ]
                    },
                    {
                        "answer_id": '9.16',
                        "answer_label": "Please explain",
                        "answer_description": "Text field [maximum 2,400 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_9.16",
                        "answer_options": []
                    },
                ]
            },
            {
                "id": '9.5b',
                "field_label": "Break down your total planned CAPEX in your current CAPEX plan for products and services (e.g. smart grids, digitalization, etc.).",
                "field_name": "(C-EU9.5b)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '9.5b0',
                        "answer_label": "Products and services",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_9.5b0",
                        "answer_options": [
                            { "key": "DistributedGeneration", "value": "Distributed generation" },
                            { "key": "HomeStorageSystems", "value": "Home storage systems" },
                            { "key": "SmartAppliances", "value": "Smart appliances" },
                            { "key": "HomeSystems", "value": "Home systems" },
                            { "key": "ProsumerServices", "value": "Prosumer services" },
                            { "key": "InformationCampaigns", "value": "Information campaigns" },
                            { "key": "Audits", "value": "Audits" },
                            { "key": "TariffMeasures", "value": "Tariff measures" },
                            { "key": "EnergyAudits", "value": "Energy audits" },
                            { "key": "EnergyManagementServices", "value": "Energy management services" },
                            { "key": "ElectricVehicles", "value": "Electric vehicles" },
                            { "key": "ChargingNetworks", "value": "Charging networks" },
                            { "key": "HeatingSystems", "value": "Heating systems" },
                            { "key": "HVAC", "value": "HVAC" },
                            { "key": "CHP", "value": "CHP" },
                            { "key": "Lighting", "value": "Lighting" },
                            { "key": "SmartGrid", "value": "Smart grid" },
                            { "key": "MicroGrid", "value": "Micro-grid" },
                            { "key": "LargeScaleStorage", "value": "Large-scale storage" },
                            { "key": "Other", "value": "Other please specify" }
                        ]
                    },
                    {
                        "answer_id": '9.5b1',
                        "answer_label": "Description of product/service",
                        "answer_description": "Text field [maximum 2,400 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_9.5b1",
                        "answer_options": []
                    },
                    {
                        "answer_id": '9.5b2',
                        "answer_label": "CAPEX planned for product/service",
                        "answer_description": "Numerical field [enter a number from 0-999,999,999,999,999 using a maximum of 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_9.5b2",
                        "answer_options": []
                    },
                    {
                        "answer_id": '9.5b3',
                        "answer_label": "Percentage of total CAPEX planned for products and services",
                        "answer_description": "Numerical field [enter a number from 0-100 using a maximum of 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_9.5b3",
                        "answer_options": []
                    },
                    {
                        "answer_id": '9.5b4',
                        "answer_label": "End year of CAPEX plan",
                        "answer_description": "Numerical field [enter a number from 2023-2100]",
                        "answer_type": "number",
                        "answer_name": "answer_9.5b4",
                        "answer_options": []
                    },
                ]
            },
            {
                "id": 'C-CE9.6',
                "field_label": "Does your organization invest in research and development (R&D) of low-carbon products or services related to your sector activities?",
                "field_name": "(C-CE9.6/C-CG9.6/C-CH9.6/C-CN9.6/C-CO9.6/C-EU9.6/C-MM9.6/C-OG9.6/C-RE9.6/C-ST9.6/C-TO9.6/C-TS9.6)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '9.60',
                        "answer_label": "Investment in low-carbon R&D",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_9.60",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                        ]
                    },
                    {
                        "answer_id": '9.61',
                        "answer_label": "Comment",
                        "answer_description": "Text field [maximum 2,400 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_9.61",
                        "answer_options": []
                    },
                ]
            },
            {
                "id": 'C-CO9.6a',
                "field_label": "Provide details of your organization's investments in low-carbon R&D for your sector activities over the last three years.",
                "field_name": "(C-CO9.6a/C-EU9.6a/C-OG9.6a)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '9.6a0',
                        "answer_label": "Technology area(Coal)",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_9.6a0",
                        "answer_options": [
                            { "key": "ControlSystems", "value": "Control systems" },
                            { "key": "CarbonCapture", "value": "Carbon capture, utilization, and storage (CCUS)" },
                            { "key": "CoalBedMethaneCapture", "value": "Coal bed methane capture" },
                            { "key": "CombustionOptimization", "value": "Combustion optimization and modification" },
                            { "key": "MonitoringSystems", "value": "Monitoring systems to reduce emissions" },
                            { "key": "ProcessImprovements", "value": "Process improvements" },
                            { "key": "RenewableEnergy", "value": "Renewable energy" },
                            { "key": "Other", "value": "Other please specify" },
                            { "key": "UnableToDisaggregate", "value": "Unable to disaggregate by technology area" }
                        ],
                    },
                    {
                        "answer_id": '9.6a1',
                        "answer_label": "Technology area(Electric Utilities)",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_9.6a1",
                        "answer_options": [
                            { "key": "BatteryStorage", "value": "Battery storage" },
                            { "key": "CarbonCapture", "value": "Carbon capture, utilization, and storage (CCUS)" },
                            { "key": "DemandResponse", "value": "Demand response" },
                            { "key": "TransmissionTechnology", "value": "Efficient transmission technology" },
                            { "key": "HydropowerGeneration", "value": "Hydropower energy generation" },
                            { "key": "MechanicalStorage", "value": "Mechanical storage" },
                            { "key": "NuclearGeneration", "value": "Nuclear energy generation" },
                            { "key": "OceanThermalGeneration", "value": "Ocean thermal energy generation" },
                            { "key": "SmartGridIntegration", "value": "Smart grid integration" },
                            { "key": "SolarGeneration", "value": "Solar energy generation" },
                            { "key": "TidalGeneration", "value": "Tidal energy generation" },
                            { "key": "WaveGeneration", "value": "Wave energy generation" },
                            { "key": "WindGeneration", "value": "Wind energy generation" },
                            { "key": "Other", "value": "Other, please specify" },
                            { "key": "UnableToDisaggregate", "value": "Unable to disaggregate by technology area" }
                        ]
                    },
                    {
                        "answer_id": '9.6a2',
                        "answer_label": "Technology area(Oil and Gas)",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_9.6a2",
                        "answer_options": [
                            { "key": "AdvancedMonitoring", "value": "Advanced monitoring techniques" },
                            { "key": "AlternativeLiquidFuels", "value": "Alternative liquid fuels" },
                            { "key": "CarbonCapture", "value": "Carbon capture, utilization, and storage (CCUS)" },
                            { "key": "EnergyEfficiencyTransport", "value": "Energy efficiency in transport" },
                            { "key": "Hydrogen", "value": "Hydrogen" },
                            { "key": "HydrogenStorage", "value": "Hydrogen storage" },
                            { "key": "MethaneReforming", "value": "Methane reforming with CCUS" },
                            { "key": "Pipeline", "value": "Pipeline" },
                            { "key": "Other", "value": "Other, please specify" },
                            { "key": "UnableToDisaggregate", "value": "Unable to disaggregate by technology area" }
                        ]
                    },

                    {
                        "answer_id": '9.6a3',
                        "answer_label": "Stage of development in the reporting year",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_9.6a3",
                        "answer_options": [
                            { "key": "BasicResearch", "value": "Basic academic/theoretical research" },
                            { "key": "AppliedResearch", "value": "Applied research and development" },
                            { "key": "PilotDemonstration", "value": "Pilot demonstration" },
                            { "key": "FullDemonstration", "value": "Full/commercial-scale demonstration" },
                            { "key": "SmallScaleDeployment", "value": "Small scale commercial deployment" },
                            { "key": "LargeScaleDeployment", "value": "Large scale commercial deployment" }
                        ]
                    },
                    {
                        "answer_id": '9.6a4',
                        "answer_label": "Average % of total R&D investment over the last 3 years",
                        "answer_description": "Numerical field [enter a number from 0-100 using a maximum of 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_9.6a4",
                        "answer_options": []
                    },
                    {
                        "answer_id": '9.6a5',
                        "answer_label": "R&D investment figure in the reporting year (unit currency as selected in C0.4) (optional)",
                        "answer_description": "Numerical field [enter a number from 0-999,999,999,999,999 using a maximum of 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_9.6a5",
                        "answer_options": []
                    },
                    {
                        "answer_id": '9.6a6',
                        "answer_label": "Average % of total R&D investment planned over the next 5 years",
                        "answer_description": "Numerical field [enter a number from 0-100 using a maximum of 2 decimal places]",
                        "answer_type": "number",
                        "answer_name": "answer_9.6a6",
                        "answer_options": []
                    },
                    {
                        "answer_id": '9.6a7',
                        "answer_label": "Explain how your R&D investment in this technology area is aligned with your climate commitments and/or climate transition plan",
                        "answer_description": "Text field [maximum 2,500 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_9.6a7",
                        "answer_options": []
                    },
                ]
            },
            {
                "id": 10,
                "field_label": "C10 Verification",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": '10.1',
                "field_label": "Indicate the verification/assurance status that applies to your reported emissions.",
                "field_name": "(C10.1)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '10.10',
                        "answer_label": "Scope 1",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_10.10",
                        "answer_options": [
                            { "key": "NoEmissionsData", "value": "No emissions data provided" },
                            { "key": "NoVerification", "value": "No third-party verification or assurance" },
                            { "key": "VerificationInPlace", "value": "Third-party verification or assurance process in place" }
                        ]
                    },
                    {
                        "answer_id": '10.11',
                        "answer_label": "Scope 2   (location-based or market-based)",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_10.11",
                        "answer_options": [
                            { "key": "NoEmissionsData", "value": "No emissions data provided" },
                            { "key": "NoVerification", "value": "No third-party verification or assurance" },
                            { "key": "VerificationInPlace", "value": "Third-party verification or assurance process in place" }
                        ]
                    },
                    {
                        "answer_id": '10.12',
                        "answer_label": "Scope 3",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_10.12",
                        "answer_options": [
                            { "key": "NoEmissionsData", "value": "No emissions data provided" },
                            { "key": "NoVerification", "value": "No third-party verification or assurance" },
                            { "key": "VerificationInPlace", "value": "Third-party verification or assurance process in place" }
                        ]
                    },
                ]
            },
            {
                "id": '10.1a',
                "field_label": "Provide further details of the verification/assurance undertaken for your Scope 1  emissions and attach the relevant statements.",
                "field_name": "(C10.1a)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '10.1a0',
                        "answer_label": "Verification or assurance cycle in place",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_10.1a0",
                        "answer_options": [
                            { "key": "AnnualProcess", "value": "Annual process" },
                            { "key": "BiennialProcess", "value": "Biennial process" },
                            { "key": "TriennialProcess", "value": "Triennial process" }
                        ]
                    },
                    {
                        "answer_id": '10.1a1',
                        "answer_label": "Status in the current reporting year",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_10.1a1",
                        "answer_options": [
                            { "key": "NoVerification", "value": "No verification or assurance of current reporting year" },
                            { "key": "UnderwayFirstYear", "value": "Underway but not complete for current reporting year - first year it has taken place" },
                            { "key": "UnderwayPreviousStatement", "value": "Underway but not complete for reporting year - previous statement of process attached" },
                            { "key": "Complete", "value": "Complete" }
                        ]
                    },
                    {
                        "answer_id": '10.1a2',
                        "answer_label": "Type of verification or assurance",
                        "answer_description": "Select from:",
                        "answer_type": "radio",
                        "answer_name": "answer_10.1a2",
                        "answer_options": [
                            { "key": "NotApplicable", "value": "Not applicable" },
                            { "key": "LimitedAssurance", "value": "Limited assurance" },
                            { "key": "ModerateAssurance", "value": "Moderate assurance" },
                            { "key": "ReasonableAssurance", "value": "Reasonable assurance" },
                            { "key": "HighAssurance", "value": "High assurance" },
                            { "key": "ThirdPartyVerificationUnderway", "value": "Third party verification/assurance underway" }
                        ]
                    },
                    {
                        "answer_id": '10.1a3',
                        "answer_label": "Attach the statement",
                        "answer_description": "Attach your document here",
                        "answer_type": "file",
                        "answer_name": "answer_10.1a3",
                        "answer_options": []
                    },
                    {
                        "answer_id": '10.1a4',
                        "answer_label": "Page/section reference",
                        "answer_description": "Text field [maximum 500 characters]",
                        "answer_type": "text",
                        "answer_name": "answer_10.1a4",
                        "answer_options": []
                    },
                    {
                        "answer_id": '10.1a5',
                        "answer_label": "Relevant standard",
                        "answer_description": "Select from drop-down options below",
                        "answer_type": "dropdown",
                        "answer_name": "relevant_standard_10.1a5",
                        "answer_options": [
                            { "key": "AA1000AS", "value": "AA1000AS" },
                            { "key": "ABNTNBRISO140642007", "value": "ABNT NBR ISO 14064-3:2007 (Associação Brasileira de Normas Técnicas)" },
                            { "key": "AdvancedTechnologiesPromotionSubsidySchemeWithEmissionReductionTargetASSET", "value": "Advanced technologies promotion Subsidy Scheme with Emission reduction Target (ASSET)" },
                            { "key": "AirportCarbonAccreditationACA", "value": "Airport Carbon Accreditation (ACA) des Airports Council International Europe" },
                            { "key": "AlbertaTechnologyInnovationAndEmissionsReductionTIER", "value": "Alberta Technology Innovation and Emissions Reduction (TIER)" },
                            { "key": "ASAE3000", "value": "ASAE3000" },
                            { "key": "AttestationStandardsEstablishedByAICPAAT105", "value": "Attestation standards established by AICPA (AT105)" },
                            { "key": "AustralianNationalGHGEmissionRegulationNGER", "value": "Australian National GHG emission regulation (NGER)" },
                            { "key": "CaliforniaMandatoryGHGReportingRegulationsCARB", "value": "California Mandatory GHG Reporting Regulations (CARB)" },
                            { "key": "CanadianInstituteOfCharteredAccountantsCICAHandbookAssuranceSection5025", "value": "Canadian Institute of Chartered Accountants (CICA) Handbook: Assurance Section 5025" },
                            { "key": "CarbonTrustStandard", "value": "Carbon Trust Standard" },
                            { "key": "ChicagoClimateExchangeCCXVerificationStandard", "value": "Chicago Climate Exchange (CCX) verification standard" },
                            { "key": "TheClimateRegistrysGeneralVerificationProtocol", "value": "The Climate Registry's General Verification Protocol (also known as California Climate Action Registry (CCAR))" },
                            { "key": "CompagnieNationaleDesCommissairesAuxComptesCNCC", "value": "Compagnie Nationale des Commissaires aux Comptes (CNCC)" },
                            { "key": "CorporateGHGVerificationGuidelinesFromERT", "value": "Corporate GHG verification guidelines from ERT" },
                            { "key": "DNVVeriSustainProtocolVerificationProtocolForSustainabilityReporting", "value": "DNV VeriSustain Protocol/ Verification Protocol for Sustainability Reporting" },
                            { "key": "DutchStandard3000A", "value": "Dutch Standard 3000A" },
                            { "key": "EarthcheckCertification", "value": "Earthcheck Certification" },
                            { "key": "ERMGHGPerformanceDataAssuranceMethodology", "value": "ERM GHG Performance Data Assurance Methodology" },
                            { "key": "EuropeanUnionEmissionsTradingSystemEUETS", "value": "European Union Emissions Trading System (EU ETS)" },
                            { "key": "IDWPS821", "value": "IDW PS 821: IDW Prüfungsstandard: Grundsätze ordnungsmäßiger Prüfung oder prüferischer Durchsicht von Berichten im Bereich der Nachhaltigkeit" },
                            { "key": "IDWAsS821", "value": "IDW AsS 821: IDW Assurance Standard: Generally Accepted Assurance Principles for the Audit or Review of Reports on Sustainability Issues" },
                            { "key": "ISAE3000", "value": "ISAE3000" },
                            { "key": "ISAE3410", "value": "ISAE 3410" },
                            { "key": "ISO140641", "value": "ISO14064-1" },
                            { "key": "ISO140643", "value": "ISO14064-3" },
                            { "key": "JapanVoluntaryEmissionsTradingSchemeJVETS", "value": "Japan voluntary emissions trading scheme (JVETS) guideline for verification" },
                            { "key": "KoreanGHGAndEnergyTargetManagementSystem", "value": "Korean GHG and energy target management system" },
                            { "key": "NMXSAA140643IMNC", "value": "NMX-SAA-14064-3-IMNC: Instituto Mexicano de Normalización y Certificación A.C" },
                            { "key": "RevR6ProcedureForAssuranceOfSustainabilityReport", "value": "RevR6 procedure for assurance of sustainability report" },
                            { "key": "SaitamaPrefectureTargetSettingEmissionsTradingProgram", "value": "Saitama Prefecture Target-Setting Emissions Trading Program" },
                            { "key": "SGSSustainabilityReportAssurance", "value": "SGS Sustainability Report Assurance" },
                            { "key": "SpanishInstituteOfRegisteredAuditorsICJCE", "value": "Spanish Institute of Registered Auditors (ICJCE)" },
                            { "key": "SSAE3000", "value": "SSAE 3000" },
                            { "key": "Standard3810NAssuranceEngagementsRelatingToSustainabilityReportsOfTheRoyalNetherlandsInstituteOfRegisteredAccountants", "value": "Standard 3810N Assurance engagements relating to sustainability reports of the Royal Netherlands Institute of Registered Accountants" },
                            { "key": "StateOfIsraelMinistryOfEnvironmentalProtectionVerificationOfGHGAndEmissionsReductionInIsraelGuidanceDocument", "value": "State of Israel Ministry of Environmental Protection, Verification of GHG and emissions reduction in Israel Guidance Document" },
                            { "key": "SwissClimateCO2LabelForBusinesses", "value": "Swiss Climate CO2 Label for Businesses" },
                            { "key": "ThaiGreenhouseGasManagementOrganisationTGOGreenhouseGasGHGVerificationProtocol", "value": "Thai Greenhouse Gas Management Organisation (TGO) Greenhouse Gas (GHG) Verification Protocol" },
                            { "key": "ToitUEnvirocaresCarbonreduceCertificationStandard", "value": "Toitū Envirocare’s carbonreduce certification standard" },
                            { "key": "TokyoEmissionsTradingScheme", "value": "Tokyo Emissions Trading Scheme" },
                            { "key": "Other", "value": "Other, please specify" }
                        ]
                    },
                    {
                        "answer_id": '10.1a6',
                        "answer_label": "Proportion of reported emissions verified (%)",
                        "answer_description": "Numerical field [enter a number from 0-100 using no decimals or commas]",
                        "answer_type": "number",
                        "answer_name": "answer_10.1a6",
                        "answer_options": []
                    },
                ]
            },
            {
                "id": 11,
                "field_label": "C11 Carbon pricing",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 11.1,
                "field_label": "Are any of your operations or activities regulated by a carbon pricing system (i.e. ETS, Cap & Trade or Carbon Tax)? ",
                "field_name": "(C11.1)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 11.10,
                        "answer_label": "Select one of the following options:",
                        "answer_description": "select in any option",
                        "answer_type": "radio",
                        "answer_name": "answer_11.10",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no but we anticipate being regulated in the next three years ", "value": "No but we anticipate being regulated in the next three years No" },
                            { "key": "no and we do not anticipate being regulated in the next three years ", "value": "No and we do not anticipate being regulated in the next three years " },
                        ]
                    },
                ]
            },
            {
                "id": '11.1a',
                "field_label": "Select the carbon pricing regulation(s) which impacts your operations. ",
                "field_name": "(C11.1a)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '11.1a0',
                        "answer_label": " Select all that apply from the following options:  ",
                        "answer_description": "Select all that apply from the following options:",
                        "answer_type": "checkbox",
                        "answer_name": "answer_11.1a0",
                        "answer_options": [
                            { "key": "aberta tier-ets", "value": "Alberta TIER-ETS" },
                            { "key": "argentina carbon tax", "value": "Agertina carbon tax" },
                            { "key": "australia erf safeguard mechanism-ets", "value": "Australia ERF Safeguard Mechanism-ETS" },
                            { "key": "baja california carbon tax", "value": "Baja California carbon tax" },
                            { "key": "bc carbon tax", "value": "BC carbon tax" },
                            { "key": "bc ggirca-ets", "value": "BC GGIRCA-ETS" },
                            { "key": "bejing pilot ets", "value": "Bejing pilot ETS" },
                            { "key": "california cat-ets", "value": "California Cat-ETS" },
                            { "key": "canada fedral fuel charge", "value": "Canada fedral fuel charge" },
                            { "key": "canada fedral output based pricing system(obps)-ets", "value": "Canada fedral Output Based Pricing System(OBPS)-ETS" },
                            { "key": "chile carbon tax", "value": "Chile carbon tax" },
                            { "key": "china national ets", "value": "China national ETS" },
                            { "key": "Chongquing pilot ets", "value": "Chongquing pilot Ets" },
                            { "key": "colombia carbon tax", "value": "Colombia carbon tax" },
                            { "key": "denmark carbon tax", "value": "Denmark carbon tax" },
                            { "key": "Estonia carbon tax", "value": "Estonia carbon tax" },
                            { "key": "eu ets", "value": "EU ETS" },
                            { "key": "finland carbon tax", "value": "Finland carbon tax" },
                            { "key": "france cabon tax", "value": "France carbon tax" },
                            { "key": "fujian pilot ets", "value": "Fujian pilot ETS" },
                            { "key": "germany ets", "value": "Germany ETS" },
                            { "key": "guangdong pilot ets", "value": "Guangdong pilot ETS" },
                            { "key": "hubaie pilot ets", "value": "Hubei pilot ETS" },
                            { "key": "iceland carbon tax", "value": "Iceland carbon tax" },
                            { "key": "ireland carbon tax", "value": "Ireland carbon tax" },
                            { "key": "japan carbon tax", "value": "Japan carbon tax" },
                            { "key": "kazakstan ets", "value": "Kazakstan ETS" },
                            { "key": "korea ets", "value": "Korea ETS" },
                            { "key": "latviacarbon tax", "value": "Latvia cabon tax" },
                            { "key": "liechtenstein carbon tax", "value": "Liechtenstein carbon tax" },
                            { "key": "luxembourge carbon tax", "value": "Luxembourge carbon tax" },
                            { "key": "massachusetts state ets", "value": "Massachusetts state ETS" },
                            { "key": "mexico carbon tax", "value": "Mexico carbon tax" },
                            { "key": "netherland carbon tax", "value": "Netherland carbon tax" },
                            { "key": "new brunswick carbon tax", "value": "New Brunswick carbon tax" },
                            { "key": "new brunswick ets", "value": "New Brunswick ETS" },
                            { "key": "new zealand ets", "value": "New Zealand ETS" },
                            { "key": "newfoundland and labrador carbon tax", "value": "NewFoundland and Labrador carbon tax" },
                            { "key": "newfoundland and labrador pss-ets", "value": "Newfoundland and Labrador PSS-ETS" },
                            { "key": "noethwest terretories carbon tax", "value": "Northwest Territories carbon tax" },
                            { "key": "norway carbon tax", "value": "Norway carbon tax" },
                            { "key": "nova scotia cat-ets", "value": "Nova Scotia CaT-ETS" },
                            { "key": "ontario eps-ets", "value": "Ontario EPS - ETS" },
                            { "key": "oregon ets", "value": "Oregon Ets" },
                            { "key": "poland carbon tax", "value": "Poland carbon tax" },
                            { "key": "portugal carbon tax", "value": "Portugal carbon tax" },
                            { "key": "prince edward island carbon tax", "value": "Prince Edward Island carbon tax" },
                            { "key": "quebec cat-ets", "value": "Quebec CaT-ETS" },
                            { "key": "rggi-ets", "value": "RGGI-ETS" },
                            { "key": "saitama ets", "value": "Saitama ETS" },
                            { "key": "saskatchewan obps-ets", "value": "Saskatchewan OBPS-ETS" },
                            { "key": "shanghai pilot ets", "value": "Shanghai pilot ETS" },
                            { "key": "Shenzhen pilot ets", "value": "Shenzhen pilot ETS" },
                            { "key": "singapore carbon tax", "value": "Singapore carbon tax" },
                            { "key": "solvenia carbon tax", "value": "Slovenia carbon tax" },
                            { "key": "south africe carbon tax", "value": "South Africa carbon tax" },
                            { "key": "spain carbon tax", "value": "Spain carbon tax" },
                            { "key": "sweden carbon tax", "value": "Sweden carbon tax" },
                            { "key": "switzerland carbon tax", "value": "Switzerland carbon tax" },
                            { "key": "switzerland ets", "value": "Switzerland ETS" },
                            { "key": "tamaulipas carbon tax", "value": "Tamaulipas carbon tax" },
                            { "key": "tianjin pilot ETS", "value": "Tianjin pilot ETS " },
                            { "key": "tokyo cat-ets", "value": "Tokyo CaT - ETS  " },
                            { "key": "uk carbon price support", "value": "UK Carbon Price Support " },
                            { "key": "uk ets", "value": "UK ETS " },
                            { "key": "ukraine carbon tax", "value": "Ukraine carbon tax" },
                            { "key": "uruguay co2 tax", "value": "Uruguay CO2 tax " },
                            { "key": "washington car ets", "value": "Washington CAR – ETS " },
                            { "key": "zacatecas carbon tax", "value": "Zacatecas carbon tax " },
                            { "key": "other ets please specify", "value": "Other ETS please specify " },
                        ]
                    },

                ]
            },
            {
                "id": '11.1b',
                "field_label": "Complete the following table for each of the emissions trading schemes you are regulated by.  ",
                "field_name": "(C11.1b)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '11.1b0',
                        "answer_label": " System Name:  ",
                        "answer_description": "Fixed   table rows are populated by selection in C11.1a ",
                        "answer_type": "Textarea",
                        "answer_name": "answer_11.1b0",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.1b1',
                        "answer_label": " % of Scope 1 emissions covered by the ETS   ",
                        "answer_description": "Numerical field [enter a number from 0-100 using a maximum of 2 decimal places and no commas] ",
                        "answer_type": "number",
                        "answer_name": "answer_11.1b1",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.1b2',
                        "answer_label": " % of Scope 2 emissions covered by the ET   ",
                        "answer_description": "Numerical field [enter a number from 0-100 using a maximum of 2 decimal places and no commas] ",
                        "answer_type": "number",
                        "answer_name": "answer_11.1b2",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.1b3',
                        "answer_label": " Period start date    ",
                        "answer_description": "Enter the start date that applies to the data in the row. Use the calendar button or enter dates manually in the format DD/MM/YYYY. Please note that the period reported should overlap with the reporting yea ",
                        "answer_type": "date",
                        "answer_name": "answer_11.1b3",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.1b4',
                        "answer_label": " Period end date    ",
                        "answer_description": "Enter the start date that applies to the data in the row. Use the calendar button or enter dates manually in the format DD/MM/YYYY. Please note that the period reported should overlap with the reporting yea ",
                        "answer_type": "date",
                        "answer_name": "answer_11.1b4",
                        "answer_options": []

                    },

                    {
                        "answer_id": '11.1b5',
                        "answer_label": " Allowances allocated     ",
                        "answer_description": "Numerical field [enter a number from 0-99,999,999,999 using a maximum of 2 decimal places and no commas]  ",
                        "answer_type": "number",
                        "answer_name": "answer_11.1b5",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.1b6',
                        "answer_label": " Allowances Purchased     ",
                        "answer_description": "Numerical field [enter a number from 0-99,999,999,999 using a maximum of 2 decimal places and no commas]  ",
                        "answer_type": "number",
                        "answer_name": "answer_11.1b6",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.1b7',
                        "answer_label": " Verified Scope 1 emissions in metric tons CO2e      ",
                        "answer_description": "Numerical field [enter a number from 0-99,999,999,999 using a maximum of 2 decimal places and no commas]  ",
                        "answer_type": "number",
                        "answer_name": "answer_11.1b7",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.1b8',
                        "answer_label": "Verified Scope 2 emissions in metric tons CO2e      ",
                        "answer_description": "Numerical field [enter a number from 0-99,999,999,999 using a maximum of 2 decimal places and no commas] ",
                        "answer_type": "number",
                        "answer_name": "answer_11.1b8",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.1b9',
                        "answer_label": " Details of ownership      ",
                        "answer_description": "Select from",
                        "answer_type": "checkbox",
                        "answer_name": "answer_11.1b9",
                        "answer_options": [
                            { "key": "Facilities we own and operate", "value": "Facilities we own and operate " },
                            { "key": "Facilities we own but do not operate ", "value": "Facilities we own but do not operate " },
                            { "key": "Facilities we operate but do not own", "value": "Facilities we operate but do not own " },
                            { "key": "Other Please Specify", "value": "Other Please Specify" },

                        ]

                    },
                    {
                        "answer_id": '11.1b10',
                        "answer_label": " Comments     ",
                        "answer_description": "Comments ",
                        "answer_type": "text",
                        "answer_name": "answer_11.1b10",
                        "answer_options": []

                    },


                ]
            },
            {
                "id": '11.1c',
                "field_label": "Complete the following table for each of the emissions trading schemes you are regulated by.  ",
                "field_name": "(C11.1c)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '11.1c0',
                        "answer_label": " Tax system   ",
                        "answer_description": "Fixed   table rows are populated by selection in C11.1a ",
                        "answer_type": "text",
                        "answer_name": "answer_11.1c0",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.1c1',
                        "answer_label": " Period Start Date   ",
                        "answer_description": "Enter the start date that applies to the data in the row. Use the calendar button or enter dates manually in the format DD/MM/YYYY. Please note that the period reported should overlap with the reporting year.  ",
                        "answer_type": "date",
                        "answer_name": "answer_11.1c1",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.1c2',
                        "answer_label": " Period End Date   ",
                        "answer_description": "Enter the start date that applies to the data in the row. Use the calendar button or enter dates manually in the format DD/MM/YYYY. Please note that the period reported should overlap with the reporting year. ",
                        "answer_type": "date",
                        "answer_name": "answer_11.1c2",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.1c3',
                        "answer_label": " % of total Scope 1 emissions covered by tax     ",
                        "answer_description": "Numerical field [enter a number from 0-100 using a maximum of 2 decimal places and no commas]  ",
                        "answer_type": "number",
                        "answer_name": "answer_11.1c3",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.1c4',
                        "answer_label": " Total cost of tax paid     ",
                        "answer_description": "Numerical field [enter a number from   0-999,999,999,999,999 using a maximum of 2 decimal places and no commas]  ",
                        "answer_type": "number",
                        "answer_name": "answer_11.1c4",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.1c5',
                        "answer_label": " Comments     ",
                        "answer_description": "Comments ",
                        "answer_type": "text",
                        "answer_name": "answer_11.1c5",
                        "answer_options": []

                    },
                ]
            },
            {
                "id": '11.1d',
                "field_label": "Give a general description and introduction to your organization.",
                "field_name": "(11.1d)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '11.1d0',
                        "answer_label": "",
                        "answer_description": "",
                        "answer_type": "textarea",
                        "answer_name": "answer_11.1d",
                        "answer_options": []
                    }
                ]
            },
            {
                "id": '11.2',
                "field_label": " Has your organization canceled any project-based carbon credits within the reporting year? ",
                "field_name": "(11.2)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '11.2',
                        "answer_label": "Select one of the following options: ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_11.2",
                        "answer_options": [
                            { "key": "yes", "value": " Yes " },
                            { "key": "no", "value": "No" },
                        ]
                    }
                ]
            },
            {
                "id": '11.2a',
                "field_label": " Provide details of the project-based carbon credits canceled by your organization in the reporting year.   ",
                "field_name": "(C11.2a)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '11.2a0',
                        "answer_label": " Project type    ",
                        "answer_description": "Select From ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_11.2a0",
                        "answer_options": [
                            { "key": "afforestation", "value": " Afforestation " },
                            { "key": "agriculture", "value": "Agriculture" },
                            { "key": "agroforestry", "value": " Agroforestry " },
                            { "key": "biochar", "value": "Biochar" },
                            { "key": "bioenergy with carbon capture and storage (BECCS)", "value": "Bioenergy with carbon capture and storage (BECCS) " },
                            { "key": "biomass energy", "value": "Biomass Energy" },
                            { "key": "cement", "value": " Cement" },
                            { "key": "coal mine", "value": "Coal Mine" },
                            { "key": "clean cookstove distribution", "value": " Clean cookstove distribution " },
                            { "key": "community project", "value": "Community Project" },
                            { "key": "direct air capture (DAC)", "value": " Direct air capture (DAC) " },
                            { "key": "energy distribution ", "value": "Energy distribution " },
                            { "key": "energy efficiency: households ", "value": " Energy efficiency: households " },
                            { "key": "energy efficiency: industry ", "value": "Energy efficiency: industry " },
                            { "key": "energy efficiency: own industry ", "value": " Energy efficiency: Own Industry  " },
                            { "key": "energy efficiency: supply side ", "value": "Energy efficiency: Supply side" },
                            { "key": "enhanced weathering and ocean alkalization ", "value": " Enhanced weathering and ocean alkalization  " },
                            { "key": "forest ecosystem restoration ", "value": "Forest ecosystem restoration " },
                            { "key": "fossil fuel switch ", "value": " Fossil fuel switch  " },
                            { "key": "fugitive", "value": "Fugitive" },
                            { "key": "geothermal", "value": " Geothermal" },
                            { "key": "hfc", "value": "HFC" },
                            { "key": "hydro", "value": " Hydro " },
                            { "key": "landfill gas", "value": "Landfill gas" },
                            { "key": "landscape project", "value": "Landscape Project" },
                            { "key": "natural regeneration", "value": " Natural Regeneration " },
                            { "key": "mangrove protection and restoration", "value": "Mangrove protection and restoration" },
                            { "key": "pfc and sf6", "value": " PFC and SF6 " },
                            { "key": "reforestation", "value": "Reforestation" },
                            { "key": "soil carbon sequestration", "value": "Soil carbon sequestration" },
                            { "key": "Solar", "value": " Solar " },
                            { "key": "tidal", "value": "Tidal" },
                            { "key": "transport", "value": " Transport " },
                            { "key": "waste management ", "value": "Waste management" },
                            { "key": "wind", "value": "Wind" },
                            { "key": "other please specify", "value": " Other Please Specify " },

                        ]

                    },
                    {
                        "answer_id": '11.2a1',
                        "answer_label": " Type of mitigation activity    ",
                        "answer_description": " Select From  ",
                        "answer_type": "Checkbox",
                        "answer_name": "answer_11.2a1",
                        "answer_options": [
                            { "key": "emission reduction", "value": " Emission Reduction " },
                            { "key": "carbon removal", "value": "Carbon Removal" },
                        ]

                    },
                    {
                        "answer_id": '11.2ac2',
                        "answer_label": " Project Discription   ",
                        "answer_description": "Text field [maximum 2,500 characters]  ",
                        "answer_type": "text",
                        "answer_name": "answer_11.2a2",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.2a3',
                        "answer_label": " Credits canceled by your organization from this project in the reporting year (metric tons CO2e     ",
                        "answer_description": "Numerical field [enter a number from 0-100 using a maximum of 2 decimal places and no commas]  ",
                        "answer_type": "number",
                        "answer_name": "answer_11.2a3",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.2a4',
                        "answer_label": " Purpose of Cancellation     ",
                        "answer_description": "Select From ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_11.2a4",
                        "answer_options": [
                            { "key": "Compliance with a carbon pricing system ", "value": " Compliance with a carbon pricing system  " },
                            { "key": "Voluntary offsetting ", "value": "Voluntary offsetting " },
                            { "key": "other please specify", "value": "Other please specify" },

                        ]

                    },
                    {
                        "answer_id": '11.2a5',
                        "answer_label": "Are you able to report the vintage of the credits at cancellation?   ",
                        "answer_description": "Select from ",
                        "answer_type": "radio",
                        "answer_name": "answer_11.2a5",
                        "answer_options": [
                            { "key": "yes", "value": " Yes " },
                            { "key": "no", "value": "No" },
                        ]

                    },
                    {
                        "answer_id": '11.2a6',
                        "answer_label": " Vintage of credits at cancellation*    ",
                        "answer_description": "Numerical field [enter a number from 0-100 using a maximum of 2 decimal places and no commas]  ",
                        "answer_type": "number",
                        "answer_name": "answer_11.2a6",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.2a7',
                        "answer_label": " Were these credits issued to or  purchased by your organization?   ",
                        "answer_description": "Select from :  ",
                        "answer_type": "radio",
                        "answer_name": "answer_11.2a7",
                        "answer_options": [
                            { "key": "issued", "value": " Issued " },
                            { "key": "purchased", "value": "Purchased" },
                        ]

                    },
                    {
                        "answer_id": '11.2a8',
                        "answer_label": " Credits canceled by your organization from this project in the reporting year (metric tons CO2e     ",
                        "answer_description": "Numerical field [enter a number from 0-100 using a maximum of 2 decimal places and no commas]  ",
                        "answer_type": "number",
                        "answer_name": "answer_11.2a8",
                        "answer_options": [
                            { "key": "alberta TIER Emission Offset system ", "value": " Alberta TIER Emission Offset system  " },
                            { "key": "acr (American Carbon Registry) ", "value": "ACR (American Carbon Registry) " },
                            { "key": "california Air Resources Board Compliance Offset Program ", "value": "California Air Resources Board Compliance Offset Program " },
                            { "key": "car (The Climate Action Reserve) ", "value": "CAR (The Climate Action Reserve) " },
                            { "key": "ccbs (developed by the Climate, Community and Biodiversity Alliance, CCBA)  ", "value": "CCBS (developed by the Climate, Community and Biodiversity Alliance, CCBA)  " },
                            { "key": "cdm (Clean Development Mechanism) ", "value": "CDM (Clean Development Mechanism) " },
                            { "key": "emissions Reduction Fund of the Australian Government ", "value": "Emissions Reduction Fund of the Australian Government " },
                            { "key": "gold Standard ", "value": "Gold Standard " },
                            { "key": "Integrity Council for Voluntary Carbon Markets – Approved carbon crediting program ", "value": "Integrity Council for Voluntary Carbon Markets – Approved carbon crediting program " },
                            { "key": "jcm (Joint Crediting Mechanism) ", "value": "JCM (Joint Crediting Mechanism) " },
                            { "key": "ji (Joint Implementation) ", "value": "JI (Joint Implementation) " },
                            { "key": "plan vivo", "value": "Plan VIVO" },
                            { "key": "redd", "value": "REDD" },
                            { "key": "trees (The REDD+ Environmental Excellence Standard) ", "value": "TREES (The REDD+ Environmental Excellence Standard) " },
                            { "key": "t-COP (Thailand Carbon Offsetting Program) ", "value": "T-COP (Thailand Carbon Offsetting Program) " },
                            { "key": "vcs (Verified Carbon Standard) ", "value": "VCS (Verified Carbon Standard) " },
                            { "key": "ver+ (TÜV SÜD standard)", "value": "VER+ (TÜV SÜD standard)" },
                            { "key": "other private carbon crediting program, please specify ", "value": "Other private carbon crediting program, please specify " },
                            { "key": "other regulatory carbon crediting program please specify ", "value": "Other regulatory carbon crediting program please specify " },

                        ]

                    },
                    {
                        "answer_id": '11.2a9',
                        "answer_label": " Method(s) the program uses to assess additionality for this project*   ",
                        "answer_description": "Select all that apply  ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_11.2a9",
                        "answer_options": [
                            { "key": "consideration of legal requirements ", "value": "Consideration of legal requirements " },
                            { "key": "investment analysis ", "value": "Investment analysis " },
                            { "key": "barrier analysis ", "value": "Barrier analysis " },
                            { "key": "market penetration assessment ", "value": "Market penetration assessment " },
                            { "key": "Other please specify", "value": "Other please specify" },
                            { "key": "not accessed", "value": "Not accessed" },
                        ]

                    },
                    {
                        "answer_id": '11.2a10',
                        "answer_label": " Approach(es) by which the selected program requires this project to address reversal risk*    ",
                        "answer_description": "Select all that apply ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_11.2a10",
                        "answer_options": [
                            { "key": "monitoring and compensation  ", "value": " Monitoring and compensation   " },
                            { "key": "temporary crediting ", "value": "Temporary crediting " },
                            { "key": "Other please specify ", "value": " Other please specify  " },
                            { "key": "no requirement", "value": "No Requirement" },
                            { "key": "No risk of reversal ", "value": " No risk of reversal " },

                        ]

                    },
                    {
                        "answer_id": '11.2a11',
                        "answer_label": " Potential sources of leakage the selected program requires this project to have assessed*     ",
                        "answer_description": " Select all that apply  ",
                        "answer_type": "Checkbox",
                        "answer_name": "answer_11.2a11",
                        "answer_options": [
                            { "key": "upstream/downstream emissions ", "value": " Upstream/downstream emissions  " },
                            { "key": "activity-shifting", "value": "Activity-shifting" },
                            { "key": "market leakag", "value": " Market leakag " },
                            { "key": "ecological leakage ", "value": "Ecological leakage " },
                            { "key": "other please specify ", "value": " Other please specify  " },
                            { "key": "not assessed ", "value": "Not assessed " },
                        ]

                    },
                    {
                        "answer_id": '11.2a11',
                        "answer_label": " Provide details of other issues the selected program requires projects to address*      ",
                        "answer_description": "Text field [maximum 2,500 characters]  ",
                        "answer_type": "text",
                        "answer_name": "answer_11.2a11",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.2a12',
                        "answer_label": " Comments     ",
                        "answer_description": "Comments ",
                        "answer_type": "text",
                        "answer_name": "answer_11.2a11",
                        "answer_options": []

                    },

                ]
            },
            {
                "id": '11.3',
                "field_label": " Does your organization use an internal price on carbon?  ",
                "field_name": "(11.3)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '11.3',
                        "answer_label": "Select one of the following options: ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_11.3",
                        "answer_options": [
                            { "key": "yes", "value": " Yes " },
                            { "key": "no, and we don’t anticipate doing so in the next two years ", "value": " No, and we don’t anticipate doing so in the next two years " },
                            { "key": "no, but we anticipate doing so in the next two years ", "value": "No, but we anticipate doing so in the next two years " },
                        ]
                    }
                ]
            },
            {
                "id": '11.3a',
                "field_label": " Provide details of how your organization uses an internal price on carbon.  ",
                "field_name": "(C11.3a)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '11.3a0',
                        "answer_label": " Type of internal carbon price     ",
                        "answer_description": "Select From ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_11.3a0",
                        "answer_options": [
                            { "key": "shadow price", "value": " Shadow Price " },
                            { "key": "internal fee", "value": "Internal fee" },
                            { "key": "internal trading", "value": " Internal Trading " },
                            { "key": "implicit price", "value": "Implicit Price" },
                            { "key": "other please specify", "value": " Other Please Specify " },

                        ]

                    },
                    {
                        "answer_id": '11.3a1',
                        "answer_label": " How the price is determine    ",
                        "answer_description": " Select From  ",
                        "answer_type": "Checkbox",
                        "answer_name": "answer_11.3a1",
                        "answer_options": [
                            { "key": "alignment with the price of allowances under an Emissions Trading Scheme ", "value": " Alignment with the price of allowances under an Emissions Trading Scheme  " },
                            { "key": "alignment with the price of a carbon tax", "value": "Alignment with the price of a carbon tax" },
                            { "key": "social cost of carbon ", "value": " Social cost of carbon  " },
                            { "key": "price/cost of voluntary carbon offset credits", "value": "Price/cost of voluntary carbon offset credits " },
                            { "key": "cost of required measures to achieve emissions reduction targets ", "value": " Cost of required measures to achieve emissions reduction targets  " },
                            { "key": "benchmarking against peers", "value": "Benchmarking against peers" },
                            { "key": "Price with material impact on business decisions ", "value": " Price with material impact on business decisions  " },
                            { "key": "other please specify", "value": " Other Please Specify " },
                        ]

                    },
                    {
                        "answer_id": '11.3a2',
                        "answer_label": " Objective(s) for implementing this internal carbon price   ",
                        "answer_description": "Select from ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_11.3a2",
                        "answer_options": [
                            { "key": "change internal behavior ", "value": " Change internal behavior   " },
                            { "key": "drive energy efficiency ", "value": "Drive energy efficiency " },
                            { "key": "drive low-carbon investment  ", "value": " Drive low-carbon investment   " },
                            { "key": "identify and seize low-carbon opportunities ", "value": "Identify and seize low-carbon opportunities  " },
                            { "key": "navigate GHG regulations  ", "value": " Navigate GHG regulations   " },
                            { "key": "Stakeholder expectations ", "value": "Stakeholder expectations " },
                            { "key": "Reduce supply chain emissions  ", "value": " Reduce supply chain emissions " },
                            { "key": "other please specify", "value": " Other Please Specify " },
                        ]

                    },
                    {
                        "answer_id": '11.3a3',
                        "answer_label": " Scope(s) covered      ",
                        "answer_description": "Select from below  ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_11.3a3",
                        "answer_options": [
                            { "key": "scope 1 ", "value": " Scope 1   " },
                            { "key": "scope 2", "value": " Scope 2 " },
                            { "key": "scope 3 (upstreame) ", "value": " Scope 3(Upstream)  " },
                            { "key": "scope 3 (downstream) ", "value": " Scope 3 (Downstream) " },

                        ]

                    },
                    {
                        "answer_id": '11.3a4',
                        "answer_label": " Pricing approach used – spatial variance     ",
                        "answer_description": "Select From ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_11.3a4",
                        "answer_options": [
                            { "key": "Uniform ", "value": " Uniform  " },
                            { "key": "differentiated ", "value": " Differenciated " },
                            { "key": "other please specify", "value": "Other please specify" },

                        ]

                    },
                    {
                        "answer_id": '11.3a5',
                        "answer_label": "Pricing approach used – temporal variance    ",
                        "answer_description": "Select from ",
                        "answer_type": "radio",
                        "answer_name": "answer_11.3a5",
                        "answer_options": [
                            { "key": "static ", "value": " Static  " },
                            { "key": "evolutionary ", "value": " Evolutionary " },
                            { "key": "other please specify", "value": "Other please specify" },

                        ]

                    },
                    {
                        "answer_id": '11.3a6',
                        "answer_label": " Indicate how you expect the price to change over time    ",
                        "answer_description": "Numerical field [enter a number from 0-100 using a maximum of 2 decimal places and no commas]  ",
                        "answer_type": "text",
                        "answer_name": "answer_11.3a6",
                        "answer_options": []

                    },
                    {
                        "answer_id": '11.3a7',
                        "answer_label": " Actual price(s) used – manimum (currency as specified in C0.4 per metric ton CO2e)   ",
                        "answer_description": " ",
                        "answer_type": "number",
                        "answer_name": "answer_11.3a7",
                        "answer_options": [

                        ]

                    },
                    {
                        "answer_id": '11.3a8',
                        "answer_label": " Actual price(s) used – maximum (currency as specified in C0.4 per metric ton CO2e)    ",
                        "answer_description": "Numerical field [enter a number from 0-100 using a maximum of 2 decimal places and no commas]  ",
                        "answer_type": "number",
                        "answer_name": "answer_11.3a8",
                        "answer_options": [

                        ]

                    },
                    {
                        "answer_id": '11.3a9',
                        "answer_label": " Business decision-making processes this internal carbon price is applied to    ",
                        "answer_description": "Select all that apply  ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_11.3a9",
                        "answer_options": [
                            { "key": "capital expenditure ", "value": "Capital Expenditure " },
                            { "key": "procurement ", "value": "Procurement " },
                            { "key": "operation and R&D ", "value": "operation and R&D  " },
                            { "key": "opportunity management ", "value": " Opportunity Management " },
                            { "key": "Other please specify", "value": "Other please specify" },
                            { "key": "risk Management", "value": "Risk Management" },
                        ]

                    },
                    {
                        "answer_id": '11.3a10',
                        "answer_label": " Mandatory enforcement of this internal carbon price within these business decision-making processes     ",
                        "answer_description": "Select from ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_11.3a10",
                        "answer_options": [
                            { "key": "yes  ", "value": " Yes   " },
                            { "key": "Yes for some decision-making processes please specify ", "value": " Yes for some decision-making processes please specify  " },
                            { "key": "no ", "value": " No  " },


                        ]

                    },
                    {
                        "answer_id": '11.3a11',
                        "answer_label": " Explain how this internal carbon price has contributed to the implementation of your organization’s climate commitments and/or climate transition plan *     ",
                        "answer_description": "   ",
                        "answer_type": "text",
                        "answer_name": "answer_11.3a11",
                        "answer_options": [

                        ]

                    },


                ]
            },
            {
                "id": 12,
                "field_label": "C12 Engagement   ",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 12.1,
                "field_label": "  Do you engage with your value chain on climate-related issues? .",
                "field_name": "(C12.1)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 12.10,
                        "answer_label": "Select all that apply from the following options:    ",
                        "answer_description": "select in any option",
                        "answer_type": "checkbox",
                        "answer_name": "answer_12.10",
                        "answer_options": [
                            { "key": "Yes our suppliers   ", "value": " Yes our suppliers   " },
                            { "key": "Yes our customers/clients   ", "value": "Yes our customers/clients   " },
                            { "key": "Yes our investees [Financial services only]   ", "value": "Yes our investees [Financial services only]   " },
                            { "key": "Yes other partners in the value chain   ", "value": "Yes other partners in the value chain   " },
                            { "key": "No we do not engage  ", "value": "No we do not engage  " },
                        ]
                    },
                ]
            },
            {
                "id": '12.1a',
                "field_label": "  Provide details of your climate-related supplier engagement strategy.  .",
                "field_name": "(C12.1a)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '12.1a0',
                        "answer_label": "Type of engagement     ",
                        "answer_description": "select in any option",
                        "answer_type": "checkbox",
                        "answer_name": "answer_12.1a0",
                        "answer_options": [
                            { "key": " information collection (understanding supplier behavior)  ", "value": " Information collection (understanding supplier behavior) " },
                            { "key": " engagement & incentivization (changing supplier behavior)  ", "value": " Engagement & incentivization (changing supplier behavior)   " },
                            { "key": " innovation & collaboration (changing markets)  ", "value": " Innovation & collaboration (changing markets   " },
                            { "key": " other please specify   ", "value": " Other please specify  " },

                        ]
                    },
                    {
                        "answer_id": '12.1a1',
                        "answer_label": "Details of engagement    ",
                        "answer_description": "select in any option",
                        "answer_type": "checkbox",
                        "answer_name": "answer_12.1a1",
                        "answer_options": [
                            { "key": "collect GHG emissions data at least annually from suppliers  ", "value": " 	Collect GHG emissions data at least annually from suppliers    " },
                            { "key": "collect targets information at least annually from suppliers  ", "value": " Collect targets information at least annually from suppliers   " },
                            { "key": "collect climate-related risk and opportunity information at least annually from suppliers      ", "value": "Collect climate-related risk and opportunity information at least annually from suppliers     " },
                            { "key": "collect climate transition plan information at least annually from suppliers   ", "value": "Collect climate transition plan information at least annually from suppliers  " },
                            { "key": "provide training support and best practices on how to make credible renewable energy usage claims   ", "value": " Provide training support and best practices on how to make credible renewable energy usage claims   " },
                        ]
                    },
                    {
                        "answer_id": '12.1a2',
                        "answer_label": "% of suppliers by number     ",
                        "answer_description": "select in any option",
                        "answer_type": "number",
                        "answer_name": "answer_12.1a2",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '12.1a3',
                        "answer_label": "% total procurement spend (direct and indirect)     ",
                        "answer_description": "select in any option",
                        "answer_type": "number",
                        "answer_name": "answer_12.1a3",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '12.1a4',
                        "answer_label": "% of supplier-related Scope 3 emissions as reported in C6.5     ",
                        "answer_description": "select in any option",
                        "answer_type": "number",
                        "answer_name": "answer_12.1a4",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '12.1a5',
                        "answer_label": "Rationale for the coverage of your engagement    ",
                        "answer_description": "select in any option",
                        "answer_type": "text",
                        "answer_name": "answer_12.1a5",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '12.1a6',
                        "answer_label": "Impact of engagement, including measures of success  ",
                        "answer_description": "select in any option",
                        "answer_type": "text",
                        "answer_name": "answer_12.1a6",
                        "answer_options": []

                    },
                    {
                        "answer_id": '12.1a7',
                        "answer_label": "Comment    ",
                        "answer_description": "select in any option",
                        "answer_type": "text",
                        "answer_name": "answer_12.1a7",
                        "answer_options": [

                        ]
                    },

                ]
            },
            {
                "id": '12.1b',
                "field_label": "  Give details of your climate-related engagement strategy with your customers.   .",
                "field_name": "(C12.1b)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '12.1b0',
                        "answer_label": "Type of engagement     ",
                        "answer_description": "select in any option",
                        "answer_type": "checkbox",
                        "answer_name": "answer_12.1b0",
                        "answer_options": [
                            { "key": " education/information sharing    ", "value": " Education/information sharing   " },
                            { "key": " collaboration & innovation  ", "value": " Collaboration & innovation " },
                            { "key": " other please specify   ", "value": " Other please specify  " },

                        ]
                    },
                    {
                        "answer_id": '12.1b1',
                        "answer_label": "Details of engagement    ",
                        "answer_description": "",
                        "answer_type": "text",
                        "answer_name": "answer_12.1b1",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '12.1b2',
                        "answer_label": " % of customers by number      ",
                        "answer_description": "select in any option",
                        "answer_type": "number",
                        "answer_name": "answer_12.1b2",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '12.1b3',
                        "answer_label": " % customer-related Scope 3 emissions as reported in C6.5      ",
                        "answer_description": "select in any option",
                        "answer_type": "number",
                        "answer_name": "answer_12.1b3",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '12.1b4',
                        "answer_label": "Please explain the rationale for selecting this group of customers and scope of engagement      ",
                        "answer_description": "select in any option",
                        "answer_type": "text",
                        "answer_name": "answer_12.1b4",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '12.1b5',
                        "answer_label": "Impact of engagement, including measures of success      ",
                        "answer_description": "select in any option",
                        "answer_type": "text",
                        "answer_name": "answer_12.1b5",
                        "answer_options": [

                        ]
                    },


                ]
            },
            {
                "id": '12.1d',
                "field_label": "  Give details of your climate-related engagement strategy with other partners in the value chain .",
                "field_name": "(C12.1d)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '12.1d',
                        "answer_label": "Please note that when copying from another document into the ORS, formatting is not retained.       ",
                        "answer_description": "Please note that when copying from another document into the ORS, formatting is not retained.   ",
                        "answer_type": "textarea",
                        "answer_name": "answer_12.1d",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '12.1e',
                "field_label": " Why do you not engage with any elements of your value chain on climate-related issues, and what are your plans to do so in the future?  .",
                "field_name": "(C12.1e)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '12.1e',
                        "answer_label": "Please note that when copying from another document into the ORS, formatting is not retained.       ",
                        "answer_description": "Please note that when copying from another document into the ORS, formatting is not retained.   ",
                        "answer_type": "textarea",
                        "answer_name": "answer_12.1d",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": 12.4,
                "field_label": "  Have you published information about your organization’s response to climate change and GHG emissions performance for this reporting year in places other than in your CDP response? If so, please attach the publication(s) .",
                "field_name": "(C12.4)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 12.40,
                        "answer_label": "Publication    ",
                        "answer_description": "select in any option",
                        "answer_type": "checkbox",
                        "answer_name": "answer_12.40",
                        "answer_options": [
                            { "key": "In mainstream reports   ", "value": " In mainstream reports   " },
                            { "key": "In mainstream reports in line with the CDSB framework (as amended to incorporate the TCFD recommendations)   ", "value": "In mainstream reports in line with the CDSB framework (as amended to incorporate the TCFD recommendations)  " },
                            { "key": "In mainstream reports incorporating the TCFD recommendations    ", "value": "In mainstream reports incorporating the TCFD recommendations   " },
                            { "key": "In other regulatory filings    ", "value": "In other regulatory filings    " },
                            { "key": "In voluntary communications   ", "value": "In voluntary communications   " },
                            { "key": " In voluntary sustainability report  ", "value": " In voluntary sustainability report  " },
                            { "key": "No publications with information about our response to climate-related issues   and GHG emissions performance   ", "value": "No publications with information about our response to climate-related issues   and GHG emissions performance   " },
                            { "key": " Other please specify   ", "value": " Other please specify  " },
                        ]
                    },
                    {
                        "answer_id": 12.41,
                        "answer_label": "Status   ",
                        "answer_description": "select in any option",
                        "answer_type": "checkbox",
                        "answer_name": "answer_12.41",
                        "answer_options": [
                            { "key": "Complete    ", "value": " Complete   " },
                            { "key": "Underway – previous year attached  ", "value": "Underway – previous year attached   " },
                            { "key": "Underway – this is our first year    ", "value": "Underway – this is our first year   " },

                        ]
                    },
                    {
                        "answer_id": 12.42,
                        "answer_label": "Attach the document    ",
                        "answer_description": "select in any option",
                        "answer_type": "file",
                        "answer_name": "answer_12.42",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": 12.43,
                        "answer_label": "Page Reference   ",
                        "answer_description": "select in any option",
                        "answer_type": "text",
                        "answer_name": "answer_12.43",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": 12.44,
                        "answer_label": "Content element   ",
                        "answer_description": "select in any option",
                        "answer_type": "checkbox",
                        "answer_name": "answer_12.44",
                        "answer_options": [
                            { "key": "governance   ", "value": " Governance   " },
                            { "key": "statergy  ", "value": " Statergy  " },
                            { "key": "risk and opportunity  ", "value": "Risk and Opportunity  " },
                            { "key": "emmission target  ", "value": "Emmission targets  " },
                            { "key": "emmission figures ", "value": " Emmission figures  " },
                            { "key": "other metrics ", "value": "Other Metrics " },
                        ]
                    },
                    {
                        "answer_id": 12.45,
                        "answer_label": "Comment    ",
                        "answer_description": "",
                        "answer_type": "text",
                        "answer_name": "answer_12.45",
                        "answer_options": [

                        ]
                    },
                ]
            },

            {
                "id": 13,
                "field_label": "C13 Module Dependencies  ",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 13.1,
                "field_label": " Provide details for the person that has signed off (approved) your CDP climate change response. ",
                "field_name": "(C13.1)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 13.10,
                        "answer_label": "Module C13 only applies to organizations with activities in the following sectors: ",
                        "answer_description": "select in any option",
                        "answer_type": "radio",
                        "answer_name": "answer_13.10",
                        "answer_options": [
                            { "key": "agricultural commodities   ", "value": " Agricultural commodities   " },
                            { "key": "food, beverage & tobacco ", "value": "Food, beverage & tobacco " },
                            { "key": "paper & forestry ", "value": "Paper & forestry " },
                        ]
                    },
                ]
            },
            {
                "id": 14,
                "field_label": "C14 Module Dependencies   ",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 14.1,
                "field_label": " Module C14 only applies to organizations with activities in the Financial Services sector.",
                "field_name": "(C14.1)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 14.10,
                        "answer_label": " ",
                        "answer_name": "answer_14.10",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": 15,
                "field_label": "C15 Biodiversity  ",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 15.1,
                "field_label": "  Is there board-level oversight and/or executive management-level responsibility for biodiversity-related matters within your organization? ",
                "field_name": "(C15.1)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 15.10,
                        "answer_label": "Board-level oversight and/or executive management-level responsibility for biodiversity-related issues ",
                        "answer_description": "select from",
                        "answer_type": "checkbox",
                        "answer_name": "answer_15.10",
                        "answer_options": [
                            { "key": "yes both board-level oversight and executive management-level responsibility   ", "value": " Yes both board-level oversight and executive management-level responsibility    " },
                            { "key": "yes board-level oversight  ", "value": "Yes board-level oversight  " },
                            { "key": "yes executive management-level responsibility ", "value": "Yes executive management-level responsibility " },
                            { "key": "no but we plan to have both within the next two years    ", "value": " No but we plan to have both within the next two years    " },
                            { "key": "no and we do not plan to have both within the next two year ", "value": "No and we do not plan to have both within the next two year " },

                        ]
                    },
                    {
                        "answer_id": 15.12,
                        "answer_label": "Description of oversight and objectives relating to biodiversity* ",
                        "answer_description": "",
                        "answer_type": "text",
                        "answer_name": "answer_15.12",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": 15.13,
                        "answer_label": "Scope of board-level oversight [FS Only]* ",
                        "answer_description": "select that all apply",
                        "answer_type": "checkbox",
                        "answer_name": "answer_15.13",
                        "answer_options": [
                            { "key": "risks and opportunities to our own operations  ", "value": " Risks and opportunities to our own operations   " },
                            { "key": "risks and opportunities to our bank lending activities  ", "value": "Risks and opportunities to our bank lending activities  " },
                            { "key": "risks and opportunities to our investment activities  ", "value": "Risks and opportunities to our investment activities  " },
                            { "key": "risks and opportunities to our insurance underwriting activities   ", "value": " Risks and opportunities to our insurance underwriting activities    " },
                            { "key": "the impact of our own operations on biodiversity ", "value": "The impact of our own operations on biodiversity  " },
                            { "key": "the impact of our bank lending activities on biodiversit ", "value": "The impact of our bank lending activities on biodiversit " },
                            { "key": "the impact of our investing activities on biodiversity    ", "value": " The impact of our investing activities on biodiversity   " },
                            { "key": "the impact of our insurance underwriting activities on biodiversity ", "value": "The impact of our insurance underwriting activities on biodiversity  " },

                        ]
                    },
                ]
            },
            {
                "id": 15.2,
                "field_label": "  Has your organization made a public commitment and/or endorsed any initiatives related to biodiversity?  ",
                "field_name": "(C15.2)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 15.20,
                        "answer_label": "Indicate whether your organization made a public commitment or endorsed any initiatives related to biodiversity  ",
                        "answer_description": "select from",
                        "answer_type": "checkbox",
                        "answer_name": "answer_15.20",
                        "answer_options": [
                            { "key": "yes we have made public commitments and publicly endorsed initiatives related to biodiversity   ", "value": " Yes we have made public commitments and publicly endorsed initiatives related to biodiversity    " },
                            { "key": "yes we have made public commitments only   ", "value": "Yes we have made public commitments only  " },
                            { "key": "yes we have endorsed initiatives only  ", "value": "Yes we have endorsed initiatives only " },
                            { "key": "no but we plan to do so within the next 2 years   ", "value": " No but we plan to do so within the next 2 years   " },
                            { "key": "no and we do not plan to have both within the next two year ", "value": "No and we do not plan to have both within the next two year " },

                        ]
                    },
                    {
                        "answer_id": 15.21,
                        "answer_label": "Biodiversity-related public commitments ",
                        "answer_description": "Select that all apply",
                        "answer_type": "text",
                        "answer_name": "answer_15.21",
                        "answer_options": [
                            { "key": "commitment to Net Positive Gain    ", "value": "Commitment to Net Positive Gain     " },
                            { "key": " commitment to No Net Loss    ", "value": " Commitment to No Net Loss   " },
                            { "key": " adoption of the mitigation hierarchy approach    ", "value": " Adoption of the mitigation hierarchy approach   " },
                            { "key": "commitment to not explore or develop in legally designated protected areas    ", "value": " Commitment to not explore or develop in legally designated protected areas   " },
                            { "key": "commitment to respect legally designated protected areas  ", "value": "Commitment to respect legally designated protected areas  " },
                            { "key": "commitment to avoidance of negative impacts on threatened and protected species    ", "value": " Commitment to avoidance of negative impacts on threatened and protected species   " },
                            { "key": "commitment to no conversion of High Conservation Value areas    ", "value": "Commitment to no conversion of High Conservation Value areas   " },
                            { "key": "commitment to secure Free, Prior and Informed Consent (FPIC) of Indigenous Peoples  ", "value": "Commitment to secure Free, Prior and Informed Consent (FPIC) of Indigenous Peoples  " },
                            { "key": "commitment to no trade of CITES listed species   ", "value": " Commitment to no trade of CITES listed species    " },
                            { "key": "other please specify  ", "value": "Other please specify  " },
                        ]
                    },
                    {
                        "answer_id": 15.23,
                        "answer_label": "Initiatives endorsed*  ",
                        "answer_description": "select that all apply",
                        "answer_type": "checkbox",
                        "answer_name": "answer_15.23",
                        "answer_options": [
                            { "key": "cbd - Global Biodiversity Framework   ", "value": " CBD - Global Biodiversity Framework   " },
                            { "key": "sdg ", "value": "SDG  " },
                            { "key": "cites ", "value": "CITES " },
                            { "key": "f4B - Finance for Biodiversity   ", "value": " F4B - Finance for Biodiversity    " },
                            { "key": "pbaf - Partnership for Biodiversity Accounting Financials [FS only]  ", "value": "PBAF - Partnership for Biodiversity Accounting Financials [FS only]   " },
                            { "key": "other please specify  ", "value": "Other please specify  " },


                        ]
                    },
                ]
            },
            {
                "id": '15.3',
                "field_label": "  Does your organization assess the impacts and dependencies of its value chain on biodiversity?   ",
                "field_name": "(C15.3)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '15.30',
                        "answer_label": " Type of assessment      ",
                        "answer_description": "Impacts on biodiversity  ",
                        "answer_type": "",
                        "answer_name": "answer_15.30",
                        "answer_options": [


                        ]

                    },
                    {
                        "answer_id": '15.31',
                        "answer_label": " Indicate whether your organization undertakes this type of assessment    ",
                        "answer_description": " Select From  ",
                        "answer_type": "Checkbox",
                        "answer_name": "answer_15.31",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no but we plan to have both within the next two years    ", "value": " No but we plan to have both within the next two years    " },
                            { "key": "no and we do not plan to have both within the next two year ", "value": "No and we do not plan to have both within the next two year " },
                        ]

                    },
                    {
                        "answer_id": '15.32',
                        "answer_label": "Value chain stage(s) covered*   ",
                        "answer_description": "Select from ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_15.32",
                        "answer_options": [
                            { "key": "direct operation ", "value": " Direct Operation   " },
                            { "key": "upstream ", "value": "Upstream " },
                            { "key": "downstream ", "value": " Downstream   " },
                            { "key": "Portfolio ", "value": "Portfolio  " },
                        ]

                    },
                    {
                        "answer_id": '15.33',
                        "answer_label": " Portfolio activity [FS only]     ",
                        "answer_description": "Select from below  ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_15.33",
                        "answer_options": [
                            { "key": "Bank lending portfolio (Bank)  ", "value": " Bank lending portfolio (Bank)    " },
                            { "key": "Investing portfolio (Asset manager)", "value": " Investing portfolio (Asset manager) " },
                            { "key": "Investing portfolio (Asset owner) ", "value": " Investing portfolio (Asset owner)   " },
                            { "key": "Insurance underwriting portfolio (Insurance company)  ", "value": " Insurance underwriting portfolio (Insurance company)  " },

                        ]

                    },
                    {
                        "answer_id": '15.34',
                        "answer_label": " Tools and methods to assess impacts and/or dependencies on biodiversity*      ",
                        "answer_description": "Select From ",
                        "answer_type": "dropdown",
                        "answer_name": "answer_15.34",
                        "answer_options": [
                            { "key": "bfc – Biodiversity Footprint Calculator  ", "value": " BFC – Biodiversity Footprint Calculator   " },
                            { "key": "bfm – Biodiversity Footprint Methodology  ", "value": " BFM – Biodiversity Footprint Methodology  " },
                            { "key": "bim – Biodiversity Impact Metric ", "value": "BIM – Biodiversity Impact Metric " },
                            { "key": "biodiversity indicators for site-based impacts  ", "value": " Biodiversity indicators for site-based impacts  " },
                            { "key": "biological Diversity Protocol  ", "value": " Biological Diversity Protocol  " },
                            { "key": "bioscope ", "value": "Bioscope " },
                            { "key": "bisi – Biodiversity Indicators for Site-based impacts  ", "value": " BISI – Biodiversity Indicators for Site-based impacts   " },
                            { "key": "bnc – Biodiversity Net Gain Calculator ", "value": " BNGC – Biodiversity Net Gain Calculator  " },
                            { "key": "cbd – Global Biodiversity Framework ", "value": "CBD – Global Biodiversity Framework " },
                            { "key": "cbf – Corporate Biodiversity Footprint ", "value": " CBF – Corporate Biodiversity Footprint  " },
                            { "key": "cisl Biodiversity Impact Metric  ", "value": " CISL Biodiversity Impact Metric  " },
                            { "key": "f4b - Finance for Biodiversity [FS only] ", "value": "F4B - Finance for Biodiversity [FS only] " },
                            { "key": "gbs – Global Biodiversity Score ", "value": " GBS – Global Biodiversity Score   " },
                            { "key": "ibat – Integrated Biodiversity Assessment Tool  ", "value": " IBAT – Integrated Biodiversity Assessment Tool  " },
                            { "key": "LafargeHolcim ", "value": "LafargeHolcim " },
                            { "key": "pbaf – Partnership for Biodiversity Accounting Financials [FS only]  ", "value": " PBAF – Partnership for Biodiversity Accounting Financials [FS only]  " },
                            { "key": "pbf – Product Biodiversity Footprint  ", "value": " PBF – Product Biodiversity Footprint  " },
                            { "key": "star – Species Threat Abatement and Restoration metric ", "value": "STAR – Species Threat Abatement and Restoration metric " },
                            { "key": "tnfd – Taskforce on Nature-related Financial Disclosures  ", "value": " TNFD – Taskforce on Nature-related Financial Disclosures  " },
                            { "key": "wbcsd Corporate Ecosystem Services Review  ", "value": " WBCSD Corporate Ecosystem Services Review  " },
                            { "key": "other please specify", "value": "Other please specify" },

                        ]

                    },
                    {
                        "answer_id": '15.35',
                        "answer_label": "Please explain how the tools and methods are implemented and provide an indication of the associated outcome(s)*    ",
                        "answer_description": " ",
                        "answer_type": "text",
                        "answer_name": "answer_15.35",
                        "answer_options": [


                        ]

                    },

                ]
            },
            {
                "id": '15.4',
                "field_label": "  Does your organization have activities located in or near to biodiversity- sensitive areas in the reporting year?   ",
                "field_name": "(15.4)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '15.4',
                        "answer_label": "Select one of the following options: ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_15.4",
                        "answer_options": [
                            { "key": "yes", "value": " Yes " },
                            { "key": "no ", "value": " No " },
                            { "key": "not accessed ", "value": "Not accessed " },
                        ]
                    }
                ]
            },
            {
                "id": '15.4a',
                "field_label": " Provide details of your organization’s activities in the reporting year located in or near to biodiversity -sensitive areas.  ",
                "field_name": "(C15.4a)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '15.4a0',
                        "answer_label": " Classification of biodiversity -sensitive area      ",
                        "answer_description": "Select from  ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_15.4a0",
                        "answer_options": [
                            { "key": "Natura 2000 network of protected areas ", "value": "Natura 2000 network of protected areas " },
                            { "key": "UNESCO World Heritage site    ", "value": " UNESCO World Heritage site    " },
                            { "key": "Key Biodiversity Area (KBAs)  ", "value": "Key Biodiversity Area (KBAs)  " },
                        ]

                    },
                    {
                        "answer_id": '15.4a1',
                        "answer_label": " Country/area    ",
                        "answer_description": " Select From  ",
                        "answer_type": "text",
                        "answer_name": "answer_15.4a1",
                        "answer_options": [

                        ]

                    },
                    {
                        "answer_id": '15.4a2',
                        "answer_label": "Name of the biodiversity-sensitive area    ",
                        "answer_description": "Select from ",
                        "answer_type": "text",
                        "answer_name": "answer_15.4a2",
                        "answer_options": [

                        ]

                    },
                    {
                        "answer_id": '15.4a3',
                        "answer_label": " Proximity      ",
                        "answer_description": "Select from below  ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_15.4a3",
                        "answer_options": [
                            { "key": "overlap  ", "value": " Overlap    " },
                            { "key": "adjacent", "value": " Adjcent " },
                            { "key": "up to 5 km  ", "value": " Up to 5 km    " },
                            { "key": "up to 10 km  ", "value": " Up to 10 km    " },
                            { "key": "up to 25 km  ", "value": " Up to 25 km    " },
                            { "key": "up to 50 km  ", "value": " Up to 50 km    " },
                            { "key": "Up to 70 km  ", "value": " Up to 70 km    " },
                            { "key": " data not available  ", "value": " Data not available   " },


                        ]

                    },
                    {
                        "answer_id": '15.4a4',
                        "answer_label": " Briefly describe your organization’s activities in the reporting year located in or near to the selected area      ",
                        "answer_description": " ",
                        "answer_type": "text",
                        "answer_name": "answer_15.4a4",
                        "answer_options": [

                        ]

                    },
                    {
                        "answer_id": '15.4a5',
                        "answer_label": "Indicate whether any of your organization’s activities located in or near to the selected area could negatively affect biodiversity   ",
                        "answer_description": " ",
                        "answer_type": "text",
                        "answer_name": "answer_15.4a5",
                        "answer_options": [
                            { "key": "yes but mitigation measures have been implemented ", "value": " Yes, but mitigation measures have been implemented    " },
                            { "key": "yes and no mitigation measures have been implemented ", "value": " Yes, and no mitigation measures have been implemented  " },
                            { "key": "no  ", "value": " NO   " },
                            { "key": "not assessed  ", "value": " Not assessed     " },

                        ]

                    },
                    {
                        "answer_id": '15.4a6',
                        "answer_label": "Mitigation measures implemented within the selected area*   ",
                        "answer_description": " ",
                        "answer_type": "text",
                        "answer_name": "answer_15.4a6",
                        "answer_options": [
                            { "key": "site selection ", "value": " Site Selection   " },
                            { "key": "project design", "value": " Project Design " },
                            { "key": "scheduling ", "value": "Scheduling   " },
                            { "key": "physical control  ", "value": " Physical control    " },
                            { "key": "operational controls ", "value": " Operational Controls  " },
                            { "key": "abatement ontrols", "value": " Abatemeny controls " },
                            { "key": "restoration ", "value": " Restoration  " },
                            { "key": "biodiversity offsets  ", "value": " Biodiversity offsets    " },


                        ]

                    },
                    {
                        "answer_id": '15.4a7',
                        "answer_label": "Explain how your organization’s activities located in or near to the selected area could negatively affect biodiversity, how this was assessed, and describe any mitigation measures implemented*  ",
                        "answer_description": " ",
                        "answer_type": "text",
                        "answer_name": "answer_15.4a7",
                        "answer_options": [

                        ]

                    },

                ]
            },
            {
                "id": '15.5',
                "field_label": "  Does your organization have activities located in or near to biodiversity- sensitive areas in the reporting year?   ",
                "field_name": "(15.5)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '15.5',
                        "answer_label": "Have you taken any actions in the reporting period to progress your biodiversity-related commitments?  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_15.5",
                        "answer_options": [
                            { "key": "yes we are taking actions to progress our biodiversity-related commitments ", "value": " Yes we are taking actions to progress our biodiversity-related commitments  " },
                            { "key": "no we are not taking any actions to progress our biodiversity-related commitments ", "value": " No we are not taking any actions to progress our biodiversity-related commitments " },
                            { "key": "no we are not taking any actions to progress our biodiversity-related commitments but we plan to within the next two years  ", "value": "No we are not taking any actions to progress our biodiversity-related commitments but we plan to within the next two years  " },
                        ]
                    }
                ]
            },
            {
                "id": '15.6',
                "field_label": "   Does your organization use biodiversity indicators to monitor performance across its activities?  ",
                "field_name": "(15.6)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '15.60',
                        "answer_label": "Does your organization use indicators to monitor biodiversity performance?  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_15.60",
                        "answer_options": [
                            { "key": "yes we use indicators ", "value": " Yes we use indicators  " },
                            { "key": "no we do not use indicators, but plan to within the next two years  ", "value": " No we do not use indicators, but plan to within the next two years  " },
                            { "key": "no ", "value": "No " },
                        ]
                    },
                    {
                        "answer_id": '15.61',
                        "answer_label": "Indicators used to monitor biodiversity performance  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_15.61",
                        "answer_options": [
                            { "key": "state and benefit indicators ", "value": " State and benefit indicators  " },
                            { "key": "pressure indicators  ", "value": " Pressure indicators " },
                            { "key": "response indicators  ", "value": "Response indicators  " },
                        ]
                    }
                ]
            },
            {
                "id": '15.7',
                "field_label": "  Have you published information about your organization’s response to biodiversity-related issues for this reporting year in places other than in your CDP response? If so, please attach the publication(s).   ",
                "field_name": "(15.7)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '15.70',
                        "answer_label": "Report ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_15.70",
                        "answer_options": [
                            { "key": "In mainstream financial reports ", "value": " In mainstream financial reports  " },
                            { "key": "In other regulatory filings  ", "value": " In other regulatory filings  " },
                            { "key": "In voluntary sustainability report or other voluntary communications  ", "value": " In voluntary sustainability report or other voluntary communications  " },
                            { "key": "No publications ", "value": " No publications  " },

                        ]
                    },
                    {
                        "answer_id": '15.71',
                        "answer_label": "Content Element  ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "checkbox",
                        "answer_name": "answer_15.71",
                        "answer_options": [
                            { "key": "content of biodiversity-related policies or commitments ", "value": " Content of biodiversity-related policies or commitments  " },
                            { "key": "governance  ", "value": " Governance  " },
                            { "key": "impacts on biodiversity  ", "value": "Impacts on biodiversity  " },
                            { "key": "details on biodiversity indicators ", "value": " Details on biodiversity indicators  " },
                            { "key": "influence on public policy and lobbying  ", "value": " Influence on public policy and lobbying " },
                            { "key": "risks and opportunities  ", "value": "Risks and opportunities  " },
                        ]
                    },
                    {
                        "answer_id": '15.72',
                        "answer_label": "Attach the document and indicate where in the document the relevant biodiversity information is located*  ",
                        "answer_description": " ",
                        "answer_type": "text",
                        "answer_name": "answer_15.72",
                        "answer_options": [

                        ]
                    }
                ]
            },
            {
                "id": 16,
                "field_label": "C16 Signoff ",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 16.1,
                "field_label": " Provide details for the person that has signed off (approved) your CDP climate change response. ",
                "field_name": "(C16.1)",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": 16.10,
                        "answer_label": "Job Title:",
                        "answer_description": "select in any option",
                        "answer_type": "text",
                        "answer_name": "answer_16.10",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": 16.11,
                        "answer_label": "Corresponding job category ",
                        "answer_description": "select from",
                        "answer_type": "checkbox",
                        "answer_name": "answer_16.11",
                        "answer_options": [
                            { "key": "board Chairs  ", "value": " Board Chairs  " },
                            { "key": "director on board", "value": "Director on Board" },
                            { "key": "cheif executive officer (ceo)", "value": "Chief Executive Officer (CEO)" },
                            { "key": "cheif financial officer (cfo)", "value": "Chief Financial Officer (CFO)" },
                            { "key": "cheif operating officer (coo)", "value": "Chief Operating Officer (COO)" },
                            { "key": "cheif procurement officer (cpo)", "value": "Chief Procurement Officer (CPO)" },
                            { "key": "cheif risk officer (cro)", "value": "Chief Risk Officer (CRO)" },
                            { "key": "cheif sustainability officer (cso)", "value": "Chief Sustainability Officer (CSO)" },
                            { "key": "cheif investment officer (cio)", "value": "Chief Investment Officer (CIO)" },
                            { "key": "cheif credit officer (cco)", "value": "Chief Credit Officer (CCO)" },
                            { "key": "cheif underwritting officer (cuo)", "value": "Chief Underwritting Officer (CUO)" },
                            { "key": "cheif government realation officer (cgro)", "value": "Chief Government Realation Officer (CGRO)" },
                            { "key": "cheif technology officer (cto)", "value": "Chief Technology Officer (CTO)" },
                            { "key": "other c-suite  officer ", "value": "Other C-Suite Officer " },
                            { "key": "president", "value": "President" },
                            { "key": "board level committee", "value": "Board Level Committee" },
                            { "key": "general counsel", "value": "General Counsel" },
                            { "key": "other  please specify", "value": "Other  Please Specify" },
                        ]
                    },
                ]
            },

        ]
    };
    // const [formState, setFormState] = useState(formFeilds);
    const [cdpReportData, setCdpReportData] = useState([])
    const [isSaving, setIsSaving] = useState(false)
    const navigate = useNavigate();
    const year = new Date().getFullYear();

    const userdetails = JSON.parse(localStorage.getItem('userdetails'))

    const { data: companyData, isLoading: isCompanyLoading } = useFetch(`cdp?company_id=${userdetails.company_id}&year=${year}`);//dynamic yr

    useEffect(() => {
        if (!isCompanyLoading) {
            const dataToSet = !Array.isArray(companyData.data) && Object.keys(companyData.data).length > 0 ? companyData.data : formFeilds;
            setCdpReportData(dataToSet);
        }
    }, [isCompanyLoading, companyData]);

    if (isCompanyLoading) {
        return (
            <>
                <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                        <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                    </div>
                </main>
            </>
        )
    }


    const handleInputChange = (label, ansid, value) => {
        setCdpReportData(prevCdpReportData => {
            const updatedFormValues = prevCdpReportData.fields.map(formData => {
                if (formData.id === label.id) {
                    const updatedAnswers = formData.answers.map(answer => {
                        if (answer.answer_id === ansid.answer_id) {
                            if (answer.answer_type === 'checkbox') {
                                const valuesArray = answer.answer_value ? answer.answer_value.split(',') : [];
                                const valueIndex = valuesArray.indexOf(value);

                                if (valueIndex === -1) {
                                    // If checkbox is checked and value is not already present, add it
                                    valuesArray.push(value);
                                } else {
                                    // If checkbox is unchecked and value is already present, remove it
                                    valuesArray.splice(valueIndex, 1);
                                }

                                const updatedValue = valuesArray.join(',');
                                return {
                                    ...answer,
                                    answer_value: updatedValue,
                                };
                            } else {
                                return {
                                    ...answer,
                                    answer_value: value || '',
                                };
                            }
                        }
                        return answer;
                    });
                    return {
                        ...formData,
                        answers: updatedAnswers,
                    };
                }
                return formData;
            });

            return {
                ...prevCdpReportData,
                fields: updatedFormValues,
            };
        });
    };





    // const handleInputChange = (field, answer, value) => {
    //     setFormState((prevState) => ({
    //         ...prevState,
    //         [`${field.field_name}_${answer.answer_name}`]: {
    //             answer_name: answer.answer_name,
    //             value,
    //         },
    //     }));
    // };


    const saveData = (dataToSave) => {

        setIsSaving(true);
        create(dataToSave, 'cdp')
            .then(res => {
                if (res.success) {
                    navigate('/cdpqna')
                }
            })
            .finally(() => {
                setIsSaving(false);
            });
    };

    const handleSubmit = event => {
        event.preventDefault();
        const d = new Date();
        let year = d.getFullYear();
        const submitData = {
            company_id: userdetails.company_id,
            year: year,
            data: cdpReportData,
        };
        setIsSaving(true);
        saveData(submitData);
    };
    const exportCdpReport = () => {
        exportToExcel(EXPORT_CDPREPORT_API, 'cdpReport')
    };
    

    if (isSaving) {
        return (
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                </div>
            </main>
        );
    }

    return (
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2">CDP Q & A</h1>
                <div className="buttons-right">
                        <button className="btn btn-primary btn-add" onClick={() => saveData({
                            company_id: userdetails.company_id,
                            year: year,
                            data: cdpReportData,
                        })} >
                            Save 
                        </button>
                    
                    <button className='btn btn-primary btn-add' onClick={exportCdpReport} > <i class="fa-solid fa-file-import"></i> Export Report </button>
            
                    </div>
            </div>
            <form onSubmit={handleSubmit}>
                {cdpReportData.fields && cdpReportData.fields.length > 0 ? cdpReportData.fields.map((field, idx) => (

                    <div className="mt-3" key={field.id}>
                        {
                            field.field_name == "heading" ? <h1 className='heading'>{field.field_label}</h1> :
                                <div className='griform'>
                                    <br></br>
                                    {field.field_name !== "heading" &&
                                        <label htmlFor={field.field_name}><b>{field.field_name}:</b> {field.field_label}</label>}
                                    {field.answers && field.answers.length > 0 ? (field.answers.map((answer, indx) => {
                                        switch (answer.answer_type) {
                                            case 'dropdown':
                                                return (
                                                    <div>
                                                        <br></br>
                                                        <label><b>{answer.answer_label} :</b></label>
                                                        <br></br>

                                                        <select
                                                            className="form-select"
                                                            key={answer.answer_id}
                                                            name={`${field.field_name}_${answer.answer_name}`}
                                                            value={answer.answer_value}
                                                            onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                        >
                                                            <option value="">Select an option</option>
                                                            {answer.answer_options.map((option) => (
                                                                <option key={option.key} value={option.key}>
                                                                    {option.value}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                );
                                            case 'radio':
                                                return (

                                                    <div key={answer.answer_id}>
                                                        <br></br>
                                                        <label><b>{answer.answer_label} :</b></label>
                                                        {answer.answer_options.map((option) => (

                                                            <div className="form-radio" key={option.key}>
                                                                <input
                                                                    type="radio"
                                                                    name={`${field.field_name}_${answer.answer_name}`}
                                                                    value={option.key}
                                                                    checked={answer.answer_value === option.key}
                                                                    onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                                />
                                                                <label>{option.value}</label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                );
                                            case 'checkbox':
                                                return (

                                                    <div key={answer.answer_id}>
                                                        <br></br>
                                                        <label><b>{answer.answer_label} :</b></label>
                                                        {answer.answer_options.map((option) => (
                                                            <div className="form-radio" key={option.key}>
                                                                <input
                                                                    type="checkbox"
                                                                    name={`${field.field_name}_${answer.answer_name}`}
                                                                    value={option.key}
                                                                    checked={answer.answer_value && answer.answer_value.split(',').includes(option.key)}
                                                                    onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                                />
                                                                <label>{option.value}</label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                );
                                            case 'textarea':
                                                return (
                                                    <div>
                                                        <br></br>
                                                        <label><b>{answer.answer_label && `${answer.answer_label}:`}</b></label>
                                                        <br></br>
                                                        <textarea
                                                            key={answer.answer_id}
                                                            type="text"
                                                            maxLength="5000"
                                                            name={`${field.field_name}_${answer.answer_name}`}
                                                            value={answer.answer_value}
                                                            onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                            rows="3" cols="50"
                                                        />
                                                    </div>
                                                );
                                            case 'text':
                                                return (
                                                    <div>
                                                        <br></br>
                                                        <label><b>{answer.answer_label} :</b></label>
                                                        <br></br>
                                                        <input
                                                            key={answer.answer_id}
                                                            type="text"
                                                            name={`${field.field_name}_${answer.answer_name}`}
                                                            value={answer.answer_value}
                                                            onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                        />
                                                    </div>
                                                );
                                            case 'number':
                                                return (
                                                    <div>
                                                        <br></br>
                                                        <label><b>{answer.answer_label} :</b></label>
                                                        <br></br>
                                                        <input
                                                            key={answer.answer_id}
                                                            type="number"
                                                            step="0.001"
                                                            min="0"
                                                            max="999999999999"
                                                            name={`${field.field_name}_${answer.answer_name}`}
                                                            value={answer.answer_value}
                                                            onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                        />
                                                    </div>
                                                );
                                            case 'date':
                                                return (
                                                    <div>
                                                        <br></br>
                                                        <label><b>{answer.answer_label} :</b> </label>
                                                        <input
                                                            key={answer.answer_id}
                                                            type="date"
                                                            name={`${field.field_name}_${answer.answer_name}`}
                                                            value={answer.answer_value}
                                                            onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                        />
                                                    </div>
                                                );
                                            case 'file':
                                                return (
                                                    <div>
                                                        <br></br>
                                                        <label><b>{answer.answer_label} :</b> </label>
                                                        <input
                                                            key={answer.answer_id}
                                                            type="file"
                                                            id="myfile"
                                                            name={`${field.field_name}_${answer.answer_name}`}
                                                            onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                        />
                                                    </div>
                                                )
                                            default:
                                                return null;
                                        }
                                    })) :
                                        (
                                            ""
                                        )}
                                </div>}
                    </div>
                )) : (
                    <span>No cdp reports data available.</span>
                )}
                <div className="mt-3 mb-3">
                    <button className="btn btn-primary btn-add" type="submit">Submit</button>
                </div>
            </form>
        </main>
    );
};

export default GRIQNA;


